import { mapGetters, mapActions } from 'vuex';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LayoutToggle from '@/components/LayoutToggle.vue';
import ShipmentTracking from '@/components/ShipmentTracking.vue';
import Overviews from '@/components/Overviews.vue';
import Modal from '@/components/Modal.vue';
import BulkReturnStatusModal from '@/components/BulkReturnStatusModal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
// import FollowUpConversion from '@/components/FollowUpConversion.vue';
// import TrackingStatistic from '@/components/TrackingStatistic.vue';
// import TransactionChart from '@/components/charts/TransactionChart.vue';
// import CustomerChart from '@/components/charts/CustomerChart.vue';
import Invoice from '@/components/Invoice.vue';
import EvidenceModal from '@/components/EvidenceModal.vue';
// import FollowUps from '@/components/FollowUps.vue';
import PackingSlips from '@/components/PackingSlips.vue';
import OrderEdit from '@/components/OrderEdit.vue';
import OrderReminder from '@/components/OrderReminder.vue';
// import BarcodeScanner from '@/components/BarcodeScanner.vue';
// import NewBarcodeScanner from '@/components/NewBarcodeScanner.vue';
import OrderTags from '@/components/OrderTags.vue';
import InputOrder from '@/components/InputOrder.vue';
import CustomFieldColumn from '@/components/CustomFieldColumn.vue';
import TagsSelect from '@/components/TagsSelect.vue';
// import PickupModal from '@/components/PickupModal.vue';
// import PackingSlipModal from '@/components/PackingSlipModal.vue';
import OrderItems from '@/components/OrderItems.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
// import AgreementModal from '@/components/AgreementModal.vue';
// import SmartPickupModal from '@/components/SmartPickupModal.vue';
import ModalProductSnapshot from '@/components/ModalProductSnapshot.vue';
import ModalCustomizeColumns from '@/components/orders/ModalCustomizeColumns.vue';
import ModalNoticeExport from '@/components/orders/ModalNoticeExport.vue';
import productsApi from '@/api/products';
import submissionsApi, { updateEvidence } from '@/api/submissions';
import { statisticScoreboardCredit } from '@/api/statistic';
import userApi from '@/api/user';
import receiptNumbesrApi from '@/api/receipt-numbers';
import FilterProduct from '@/components/FilterProduct.vue';
import {
	followUpTokens,
	defaultOrdersColumns,
	orderStatuses,
	paymentStatuses,
	paymentMethods,
	shippingCouriers,
	storefrontAddonId,
	s3Url,
	AGREEMENTS_VERSION,
	PAYMENT_METHOD_INSTANT,
} from '@/lib/statics';
import {
	duplicateVar,
	makePDF,
	downloadFile,
	getDateRange,
	// getImageData,
	getAxiosErrorMessage,
	isFirefox,
	isWindows,
	toTitleCase,
	groupBy,
	imageURLtoBase64,
	formatMoney,
	buildQuery,
	copyToClipboard,
	// isTester,
	getShipmentIcon,
	getLastShipmentHistory,
	getPaymentInfo,
	// isChrome,
	isMobile,
	generateVariationsData,
	getOrderDisplayStatus,
} from '@/lib/helper';
import client from '@/lib/http-client';
import ordersOo from '@/api/orders-oo';

const BarcodeScanner 	= () => import(/* webpackChunkName: "barcode-scanner" */ '@/components/BarcodeScanner.vue');
const NewBarcodeScanner = () => import(/* webpackChunkName: "new-barcode-scanner" */ '@/components/NewBarcodeScanner.vue');
const SmartPickupModal 	= () => import(/* webpackChunkName: "smart-pickup" */ '@/components/SmartPickupModal.vue');
const PickupModal 		= () => import(/* webpackChunkName: "pickup-modal" */ '@/components/PickupModal.vue');
const PackingSlipModal 	= () => import(/* webpackChunkName: "packing-slip-modal" */ '@/components/PackingSlipModal.vue');
const AgreementModal 	= () => import(/* webpackChunkName: "agreement-modal" */ '@/components/AgreementModal.vue');
const SubmissionStats 	= () => import(/* webpackChunkName: "submission-stats" */ '@/components/orders/SubmissionStats.vue');
const Overview			= () => import(/* webpackChunkName: "overview" */ '@/components/Overview.vue');

dayjs.extend(customParseFormat);

const defaultFilterDate = getDateRange();

const defaultProduct = { _id: 0, name: 'All Products' };
const defaultForm = { _id: 0, name: 'All Checkout Pages' };
const defaultAdvancedFilters = {
	utm_source: '',
	utm_medium: '',
	utm_campaign: '',
	utm_term: '',
	utm_content: '',
	ip: '',
};

// Packing Slip
const packingSlips = [
	{ key: 'all', label: 'All' },
	{ key: 1, label: 'Printed' },
	{ key: 0, label: 'Not printed yet' },
];

const defaultPackingSlip = { key: 'all', label: 'All' };

// Force position on top
const popperOptions = {
	placement: 'top',
	modifiers: {
		flip: {
			enabled: false,
		},
		preventOverflow: {
			escapeWithReference: true,
		},
	},
};

export default {
	name: 'Submissions',
	components: {
		ShipmentTracking,
		Overviews,
		// TransactionChart,
		// CustomerChart,
		Modal,
		EvidenceModal,
		BulkReturnStatusModal,
		Daterangepicker,
		Invoice,
		// FollowUps,
		// FollowUpConversion,
		// TrackingStatistic,
		PackingSlips,
		OrderEdit,
		OrderReminder,
		BarcodeScanner,
		NewBarcodeScanner,
		OrderTags,
		CustomFieldColumn,
		InputOrder,
		TagsSelect,
		PickupModal,
		PackingSlipModal,
		OrderItems,
		CheckboxToggle,
		AgreementModal,
		LayoutToggle,
		SmartPickupModal,
		SubmissionStats,
		ModalProductSnapshot,
		ModalCustomizeColumns,
		FilterProduct,
		ModalNoticeExport,
		Overview,
	},
	data() {
		return {
			isFilterResellerOrder: false,
			filterKeyword: '',
			limit: 25,
			sort_by: 'created_at',
			sort: 'desc',
			orderStatus: orderStatuses,
			showStats: false,
			selectedStatus: [],
			selectedPaymentStatus: null,
			selectedPaymentMethod: null,
			selectedCouponCode: '',
			selectedProduct: defaultProduct,
			selectedForm: defaultForm,
			selectedProducts: [],
			selected: [],
			selectedSubmission: null,
			selectedSubmissions: [],
			selectedTrackingStatistic: null,
			// selectedMember: null,
			selectedMember: [],
			selectedBumpStatus: null,
			allOrdersColumns: defaultOrdersColumns,
			selectedColumns: [],
			isShowFollowUp: false,
			isShowShippingTracking: false,
			isShowPhoneCall: false,
			isShowTrackingStatistic: false,
			followUpType: '',
			followUpData: null,
			followUpTextEdit: '',
			followUpNumberEdit: '',
			followUpProduct: null,
			followUpProductDefault: {
				_id: 0,
				name: '',
				sms_gateways: [],
			},
			isShowMarkPending: false,
			isShowMarkProcessing: false,
			isShowMarkComplete: false,
			isShowMarkRefund: false,
			isShowMarkCancel: false,
			isShowMarkPaid: false,
			isShowMarkUnpaid: false,
			isShowDeleteOrderBulk: false,
			isShowDetails: false,
			isChangingStatus: false,
			isUpdatingPaymentStatus: false,
			isShowCustomerCities: false,
			isDeleting: false,
			isExporting: false,
			filterDate: duplicateVar(defaultFilterDate),
			scrollTop: 0,
			overviewItems: {
				primary: [
					'submission_count',
					'shipping_pending',
					'shipping_processed',
					'shipping_delivery',
					'shipping_completed',
				],
			},
			isPrinting: false,
			receiptNumber: '',
			isShowFilter: false,
			isShowPackingSlip: false,
			isRouteChecked: false,
			isSendingSMS: false,
			isShowCustomColumns: false,
			isSavingColumns: false,
			isShowAdvancedFilters: false,
			filters: duplicateVar(defaultAdvancedFilters),
			logo: null,
			isShowEdit: false,
			isFetchingFollowUp: false,
			filterProcessingDate: '',
			isShowReminderForm: false,
			followUpProducts: [],
			isShowBarcodeScanner: false,
			isDisplayBarcode: true,
			isUploadReceiptVisible: false,
			isUploadingReceipt: false,
			receiptFile: null,
			paymentStatus: 'paid',
			paymentStatuses,
			selectedFilterReseller: [],
			paymentMethods: [
				{ key: 'all', label: 'All' },
				{ key: 'bank_transfer', label: 'Bank Transfer' },
				{ key: 'cod', label: 'COD' },
				{ key: 'instant', label: 'E-Payment' },
			],
			listFilterResellers: [{ _id: 'all', name: 'Show All' }],
			bumpStatuses: [
				{ key: 'all', label: 'All' },
				{ key: 'checked', label: 'With Bump' },
				{ key: 'unchecked', label: 'No Bump' },
			],
			pickupStatuses: [
				{ key: 'all', label: 'All' },
				{ key: 'yes', label: 'Picked Up Orders' },
				{ key: 'no', label: 'No Pickup' },
			],
			filterPickup: null,
			filterCourier: null,
			isShowTag: false,
			tagType: '',
			tagData: [],
			filterProcessingAtSince: '',
			filterProcessingAtUntil: '',
			filterCompletedSince: '',
			filterCompletedUntil: '',
			filterPaidSince: '',
			filterPaidUntil: '',
			filterTags: [],
			isShowInputOrder: false,
			isShowBulkUpdateStatus: false,
			bulkUpdateStatus: '',
			bulkPaymentStatus: 'paid',
			selectedOrderIds: [],
			isApplyingAssignTeam: false,
			isShowAssignTeam: false,
			selectedTeam: '',
			columnFilter: '',
			selectedPackingSlip: defaultPackingSlip,
			packingSlips,
			uploadReceiptStatus: 'completed',
			since: null,
			until: null,
			isDeleted: null,
			sourceType: '',
			filterReceiptNumber: '',
			storefrontConfig: null,
			storefrontFollowUp: null,
			// orderDetails: [],
			isPickupVisible: false,
			courierLogos: [],
			ooLogo: null,
			isPaymentVisible: false,
			isCourierVisible: false,
			isPickupClicked: false,
			isPickupNoticeVisible: false,
			pickupCourier: 'jne',
			isDeviceMobile: false,
			reseller: false,
			isSmartPickupVisible: false,
			isBlockIpVisible: false,
			isBlockingIp: false,
			// isFetchingLabel: false,
			labels: [],
			productCodes: [],
			labelsFetchingStatus: [],
			submissionsLabels: [],
			filterDeliveryStatus: '',
			filterIsManifested: false,
			isShowProcessOrders: false,
			isShowModalProduct: false,
			selectedProvince: {},
			isShowEvidenceModal: false,
			evidenceUrl: '',
			isUpdatingEvidence: false,
			selectedCity: {},
			selectedSubdistrict: {},
			isModalFilterProductVisible: false,
			productIds: [],
			submissionIds: [],
			returnStatus: null,
			updatedCount: 0,
			isShowNoticeExport: false,
			credit: {
				collected_from_customer: 0,
				failed_to_collect: 0,
				have_not_collected: 0,
			},
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			getProducts: 'submissions/getProducts',
			getForms: 'submissions/getForms',
			changeProgress: 'submissions/changeProgress',
			changeStatus: 'submissions/changeStatus',
			changeStatusByOrderId: 'submissions/changeStatusByOrderId',
			updateOrders: 'submissions/updateOrders',
			delete: 'submissions/delete',
			resetSubmissions: 'submissions/resetSubmissions',
			updateSubmission: 'submissions/updateSubmission',
			updateSubmissionCustomer: 'submissions/updateSubmissionCustomer',
			updatePrinted: 'submissions/updatePrinted',
			clearForms: 'submissions/clearForms',
			updateOrderReceipts: 'submissions/updateOrderReceipts',
			resetNewOrders: 'submissions/resetNewOrders',
			changePaymentStatus: 'submissions/changePaymentStatus',
			getSubmissionTags: 'submissions/getSubmissionTags',
			updateBulkStatus: 'submissions/updateBulkStatus',
			updateBulkPaymentStatus: 'submissions/updateBulkPaymentStatus',
			updateAssignTeam: 'submissions/updateAssignTeam',
			addOrderDetail: 'submissions/addDetail',
			getMembers: 'members/fetch',
			fetchProvinces: 'productCreator/fetchProvinces',
			fetchCities: 'productCreator/fetchCities',
			fetchSubdistricts: 'productCreator/fetchSubdistricts',
		}),
		setFilterProduct(value) {
			this.isModalFilterProductVisible = value;
		},
		applyFilterProducts(productIds) {
			if (productIds.length === 1) {
				const productId = productIds[0];
				this.fetchForms(productId);
			} else {
				this.resetForm();
			}
			this.productIds = productIds;
			this.applyFilter();
		},
		toggleFilterResellerOrder() {
			if (this.selectedFilterReseller.length > 0 || (this.resellerIds !== '' && this.resellerIds !== undefined)) {
				this.isFilterResellerOrder = true;
			}
		},
		setFilterResellerOrder(val) {
			this.isFilterResellerOrder = val;
			this.filterResellerOrder(val);
		},
		toggleBarcodeScannerModal(state = true) {
			this.isShowBarcodeScanner = state;
			if (!state && this.updatedCount > 0) {
				this.fetchData(true);
				this.updatedCount = 0;
			}
		},
		incrementUpdate() {
			this.updatedCount++;
		},
		closeBulkReturnStatusModal(state = true) {
			this.isUploadReceiptVisible = state;
			if (this.updatedCount > 0) {
				this.fetchData(true);
				this.updatedCount = 0;
			}
		},
		showEvidence(submission) {
			this.selectedSubmission = submission;
			this.evidenceUrl = submission?.shipping?.evidence_url ?? '';
			this.isShowEvidenceModal = true;
		},
		updateEvidence(evidenceUrl) {
			this.isUpdatingEvidence = true;

			const submissionId = this.selectedSubmission._id;

			const payload = {
				submission_id: submissionId,
				evidence_url: evidenceUrl,
			};

			const callback = (response) => {
				const message = response?.message ?? 'Success';

				this.isUpdatingEvidence = false;
				this.isShowEvidenceModal = false;

				const currentSubmission = duplicateVar(this.selectedSubmission);
				const currentShipping = currentSubmission.shipping;
				currentShipping.evidence_url = evidenceUrl;
				currentSubmission.shipping = currentShipping;
				this.updateSubmission(currentSubmission);

				this.$notify({
					group: 'orders',
					title: 'Update Evidence',
					text: message,
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isUpdatingEvidence = false;
				this.$notify({
					group: 'orders',
					title: 'Update Evidence',
					text: message,
					type: 'error',
				});
			};

			updateEvidence(payload, callback, errorCallback);
		},
		toggleStats() {
			this.showStats = !this.showStats;
			if (this.showStats) {
				this.fetchMoreStats();
			}
		},
		handleSubmission(submission, event) {
			const isChecked = event.target.checked;
			const index = this.selectedSubmissions.findIndex(
				currSub => currSub._id === submission._id,
			);
			if (isChecked && index === -1) {
				this.selectedSubmissions.push(submission);
			} else if (!isChecked && index !== -1) {
				this.selectedSubmissions.splice(index, 1);
			}
		},
		async showFollowUp(submission, type) {
			this.followUpTextEdit = '';
			this.followUpType = type;
			this.selectedSubmission = submission;
			this.isShowFollowUp = true;
			if (submission.type === 'form') {
				const productData = this.followUpProducts.find(
					product => product._id === submission.product_id,
				);
				if (productData) {
					this.setFollowUpProduct(productData);
				} else {
					this.fetchAutoText(submission.product_id);
				}
			} else {
				const orderDetailIndex = this.orderDetails.findIndex(
					order => order._id === submission._id,
				);
				if (orderDetailIndex === -1) {
					const res = await client.get(`/submission/${submission._id}`);
					const { data: orderDetail } = res.data;
					this.addOrderDetail(orderDetail);
				}
				if (!this.storefrontConfig) {
					const res = await client.get(`/user/add_on/${storefrontAddonId}`);
					const { data: response } = res.data;
					const config = response.config;
					this.storefrontConfig = config;
				}
				this.followUpData = duplicateVar(
					this.storefrontConfig.follow_up_autotext,
				);
				this.followUpNumberEdit = duplicateVar(this.followUpNumber);
				this.followUpTextEdit = this.followUpText.slice();
			}
		},
		showShippingTracking(submission) {
			this.isShowShippingTracking = true;
			this.selectedSubmission = submission;
		},
		showFollowUpOld(submission, type) {
			this.followUpType = type;
			this.selectedSubmission = submission;
			this.isShowFollowUp = true;
			if (submission.type === 'form') {
				const productData = this.followUpProducts.find(
					product => product._id === submission.product_id,
				);
				if (productData) {
					this.setFollowUpProduct(productData);
				} else {
					this.fetchAutoText(submission.product_id);
				}
			}
		},
		showPhoneCall(submission) {
			this.selectedSubmission = submission;
			this.isShowPhoneCall = true;
			this.followUpNumberEdit = `+${duplicateVar(this.followUpNumber)}`;
		},
		showTrackingStatisticSeeMore(trackingStatistic) {
			this.selectedTrackingStatistic = trackingStatistic;
			this.isShowTrackingStatistic = true;
		},
		setFollowUpProduct(product) {
			this.followUpProduct = product;
			this.followUpNumberEdit = duplicateVar(this.followUpNumber);
			this.followUpData = product.follow_up_autotext;
			this.followUpTextEdit = this.followUpText.slice();
			const followUpDefault = {
				_id: product._id,
				name: product.name,
				sms_gateways: product.sms_gateways,
			};
			this.followUpProductDefault = followUpDefault;
		},
		fetchAutoText(productId) {
			this.isFetchingFollowUp = true;
			const callback = (response) => {
				const product = response.data;
				this.followUpProducts.push(product);
				this.setFollowUpProduct(product);
				this.isFetchingFollowUp = false;
			};
			const errorCallback = () => {
				this.isFetchingFollowUp = false;
			};
			productsApi.getProductDetails(productId, callback, errorCallback);
		},
		hideFollowUp() {
			this.isShowFollowUp = false;
			this.selectedSubmission = null;
			this.followUpTextEdit = '';
		},
		hideShippingTracking() {
			this.isShowShippingTracking = false;
			this.selectedSubmission = null;
		},
		hidePhoneCall() {
			this.isShowPhoneCall = false;
			this.selectedSubmission = null;
		},
		hideTrackingStatistic() {
			this.isShowTrackingStatistic = false;
			this.selectedTrackingStatistic = null;
		},
		followUp() {
			// Update Progress
			const callback = () => {
				// Open in new tab
				// const link = document.getElementById('new-tab-link');
				// link.href = url;
				// link.click();
			};

			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
			};

			const submissionId = this.selectedSubmission._id;

			const progress = Object.assign({}, this.selectedSubmission.progress);
			progress[this.followUpType] = true;

			const payload = {
				id: submissionId,
				progress,
			};

			this.changeProgress(payload);

			const progressJSON = JSON.stringify(progress);

			const params = {
				progress: progressJSON,
				use_queue: 0,
			};

			submissionsApi.updateProgress(
				submissionId,
				params,
				callback,
				errorCallback,
			);
		},
		followUpSms() {
			this.isSendingSMS = true;
			if (this.followUpTextEdit.trim().length === 0) {
				this.$notify({
					group: 'orders',
					title: 'Follow Up',
					text: 'Please insert SMS text',
					type: 'warn',
				});
				this.isSendingSMS = false;
			} else {
				const callback = (response) => {
					const message = response.message;

					this.$notify({
						group: 'orders',
						title: 'Follow Up',
						text: message,
						type: 'success',
					});
					this.isSendingSMS = false;
					this.hideFollowUp();
				};

				const errorCallback = (e) => {
					if (e.response) {
						const response = e.response.data;
						const errorMessage = response.message;

						this.$notify({
							group: 'orders',
							title: 'Follow Up',
							text: errorMessage,
							type: 'warn',
						});
					}
					this.isSendingSMS = false;
				};
				const submissionId = this.selectedSubmission._id;

				const params = {
					phone: this.followUpNumberEdit,
					message: this.followUpTextEdit.trim(),
					sms_gateway: 'zenziva',
				};

				submissionsApi.sendSMS(submissionId, params, callback, errorCallback);
			}
		},
		getCartItemsText(order) {
			const cartContents = [];
			const orderDetail = this.orderDetails.find(
				detail => detail._id === order._id,
			);
			if (orderDetail) {
				const products = orderDetail.products;
				const cartItems = orderDetail.cart_items;
				for (let index = 0; index < cartItems.length; index++) {
					const cartItem = cartItems[index];
					const product = products.find(
						product => product.product_id.$oid === cartItem.product_id.$oid,
					);
					const productName = product ? product.name : '-';
					const variationName = cartItem.variation
						? ` (${cartItem.variation.replace(/\|\|/g, ' - ')}) `
						: '';
					const qty = cartItem.qty ? ` (x${cartItem.qty}) ` : '';
					const price = formatMoney(cartItem.price);
					const notes =						cartItem.notes && cartItem.notes !== ''
						? ` (${cartItem.notes}) `
						: '';
					// - Product Name (Variation) (Notes) (quantity): Price
					const cartContent = `- ${productName}${variationName}${notes}${qty}: ${price}`;
					cartContents.push(cartContent);
				}
			}
			const text = cartContents.join('\n');
			return text;
		},
		generateFollowUpText(text = '') {
			if (text !== '') {
				const submission = this.selectedSubmission;
				const submissionId = submission._id;
				const customerData = submission.customer_data;
				const orderId = submission.order_id ? submission.order_id : '';
				const orderDate = submission.created_at
					? this.formatDate(submission.created_at)
					: '';
				// const orderType = submission.type;
				const customerEmail = customerData.email ? customerData.email : '';
				const customerName = customerData.name ? customerData.name : '';
				const customerPhone = customerData.phone ? customerData.phone : '';
				const customerAddress = customerData.address
					? customerData.address
					: '';
				let customerProvince = customerData.state ? customerData.state : '';
				if (customerData.province_name) {
					customerProvince = customerData.province_name;
				}
				let customerCity = customerData.city ? customerData.city : '';
				if (customerData.city_name) {
					customerCity = customerData.city_name;
				}
				let customerDistrict = customerData.district
					? customerData.district
					: '';
				if (customerData.subdistrict_name) {
					customerDistrict = customerData.subdistrict_name;
				}
				const customerZip = customerData.zip || '';
				const productName = submission.product_name
					? submission.product_name
					: '';
				const productPrice = submission.product_price
					? this.formatMoney(submission.product_price)
					: '';
				const shippingCost = submission.shipping.cost
					? this.formatMoney(submission.shipping.cost)
					: '';
				const shippingCodCost = submission.shipping.cod_cost
					? this.formatMoney(submission.shipping.cod_cost)
					: '';
				const shippingCostCodCost = submission.shipping.cost && submission.shipping.cod_cost
					? this.formatMoney(submission.shipping.cost + submission.shipping.cod_cost)
					: '';
				const shippingCourier = submission.shipping.courier
					? submission.shipping.courier.toUpperCase()
					: '';
				const shippingService = submission.shipping.service
					? submission.shipping.service
					: '';
				const shippingReceiptNumber = submission.shipping.receipt_number
					? submission.shipping.receipt_number
					: '';
				const totalPrice = submission.gross_revenue
					? this.formatMoney(submission.gross_revenue)
					: '';
				const couponCode = submission.coupon.code ? submission.coupon.code : '';
				const couponDiscount =					submission.coupon.code !== ''
					? `-${formatMoney(submission.coupon.discount)}`
					: '';
				const uniqueCodeValue = submission.unique_code_price.unique_code;
				const uniqueCodePrefix =					submission.unique_code_price.type === 'decrease' ? '-' : '';
				const uniqueCode = `${uniqueCodePrefix}${uniqueCodeValue}`;
				const bankAccounts = this.bankAccountsDisplay;
				const bumpName = submission.bump.checked ? submission.bump.name : '';
				const bumpPrice = submission.bump.checked
					? this.formatMoney(submission.bump.price)
					: '';
				const bump = submission.bump.checked ? `${bumpName}: ${bumpPrice}` : '';
				const quantity = submission.customer_data.quantity
					? submission.customer_data.quantity
					: '';
				const notes = submission.customer_data.notes
					? submission.customer_data.notes
					: '';
				const customerService = this.getTeamMember(submission);
				const csName =					customerService && customerService.name ? customerService.name : '';
				const csPhone =					customerService && customerService.phone ? customerService.phone : '';
				const csEmail =					customerService && customerService.email ? customerService.email : '';

				// Variation & Variations
				const variation = submission.customer_data.variation
					? submission.customer_data.variation
					: '';
				const isMultipleVariations = !!submission.customer_data.variations;
				const variationsData = isMultipleVariations
					? submission.customer_data.variations
					: [];
				const variationsMapper = variationData => `${variationData.value} (x${variationData.quantity})`;
				const variations = variationsData.map(variationsMapper);
				const variationsString = variations.join(',\n');
				const variationsContent = `\n${variationsString}`;
				const variationsReducer = (accumulator, variationData) => accumulator + variationData.quantity;
				const variationsQuantity = variationsData.reduce(variationsReducer, 0);

				// Dropship
				const isDropship = submission?.dropship?.enabled;
				const dropshipperName =					isDropship && submission?.dropship?.name
					? submission.dropship.name
					: '';
				const dropshipperPhone =					isDropship && submission?.dropship?.phone
					? submission.dropship.phone
					: '';

				let userId = this.user._id;
				const isOwner = this.user.role === 'owner';
				if (!isOwner) {
					userId = this.user.parent_id;
				}
				const username = this.user.username;

				const metas = submission.customer_data.meta || [];
				const customFields =					metas.length > 0
					? metas.map(meta => `${meta.label}: ${meta.value}`).join('\n')
					: '';
				const orderDetailsLink = `https://${username}.ostock.id/orders/${
					submission._id
				}`;
				const paymentConfirmationLink = `https://${username}.ostock.id/payment-confirmation?order_id=${orderId}`;

				const paymentMethodCode = submission.payment.method;
				const paymentMethod =					submission.payment.method && paymentMethods[paymentMethodCode]
					? paymentMethods[paymentMethodCode]
					: '';

				// eslint-disable-next-line camelcase
				// const productSlug = submission.product_slug || '';
				// const formId = submission.form_id || '';

				let ePaymentLink = '';
				if (paymentMethodCode === 'instant') {
					ePaymentLink = `https://payments.ostock.id/?uid=${userId}&sub=${submissionId}`;
				}

				const quantityContent = isMultipleVariations
					? variationsQuantity
					: quantity;
				const variationContent = isMultipleVariations
					? variationsContent
					: variation;

				const cartItems = this.getCartItemsText(submission);

				const substitutions = {
					order_id: orderId,
					order_date: orderDate,
					email: customerEmail,
					name: customerName,
					phone: customerPhone,
					address: customerAddress,
					province: customerProvince,
					city: customerCity,
					district: customerDistrict,
					zip: customerZip,
					product_name: productName,
					product_price: productPrice,
					// product_sale_price: productSalePrice,
					shipping_cost: shippingCost,
					shipping_cod_cost: shippingCodCost,
					shipping_cost_cod_cost: shippingCostCodCost,
					shipping_courier: shippingCourier,
					shipping_service: shippingService,
					receipt_number: shippingReceiptNumber,
					total_price: totalPrice,
					coupon_code: couponCode,
					coupon_discount: couponDiscount,
					unique_code: uniqueCode,
					bank_accounts: bankAccounts,
					bump_name_price: bump,
					bump_name: bumpName,
					bump_price: bumpPrice,
					quantity: quantityContent,
					notes,
					variation: variationContent,
					payment_link: paymentConfirmationLink,
					payment_method: paymentMethod,
					e_payment_link: ePaymentLink,
					custom_fields: customFields,
					order_details_link: orderDetailsLink,
					cs_name: csName,
					cs_phone: csPhone,
					cs_email: csEmail,
					cart_items: cartItems,
					dropshipper_name: dropshipperName,
					dropshipper_phone: dropshipperPhone,
				};

				followUpTokens.forEach((token) => {
					const replacement = substitutions[token.key]
						? substitutions[token.key]
						: '';
					text = text.replace(new RegExp(token.value, 'g'), replacement);
				});

				// CONDITIONS

				let paymentMethodKey = paymentMethodCode
					? paymentMethodCode.toUpperCase()
					: '';
				if (paymentMethodCode === 'instant') {
					paymentMethodKey = 'E_PAYMENT';
				}

				const openConditionTag = `\\[\\[${paymentMethodKey}\\]\\]`;
				const closeConditionTag = `\\[\\[/${paymentMethodKey}\\]\\]`;

				if (paymentMethodCode && paymentMethodCode !== '') {
					// text = text.replace(openConditionTag, '');
					// text = text.replace(closeConditionTag, '');
					text = text.replace(new RegExp(openConditionTag, 'g'), '');
					text = text.replace(new RegExp(closeConditionTag, 'g'), '');
					if (paymentMethodCode === 'bank_transfer') {
						text = text.replace(/\[\[COD\]\]([\s\S]*?)\[\[\/COD\]\]/g, '');
						text = text.replace(
							/\[\[E_PAYMENT\]\]([\s\S]*?)\[\[\/E_PAYMENT\]\]/g,
							'',
						);
					} else if (paymentMethodCode === 'cod') {
						text = text.replace(
							/\[\[BANK_TRANSFER\]\]([\s\S]*?)\[\[\/BANK_TRANSFER\]\]/g,
							'',
						);
						text = text.replace(
							/\[\[E_PAYMENT\]\]([\s\S]*?)\[\[\/E_PAYMENT\]\]/g,
							'',
						);
					} else if (paymentMethodCode === 'instant') {
						text = text.replace(
							/\[\[BANK_TRANSFER\]\]([\s\S]*?)\[\[\/BANK_TRANSFER\]\]/g,
							'',
						);
						text = text.replace(/\[\[COD\]\]([\s\S]*?)\[\[\/COD\]\]/g, '');
					}
				} else {
					text = text.replace(/\[\[COD\]\]([\s\S]*?)\[\[\/COD\]\]/g, '');
					text = text.replace(
						/\[\[BANK_TRANSFER\]\]([\s\S]*?)\[\[\/BANK_TRANSFER\]\]/g,
						'',
					);
					text = text.replace(
						/\[\[E_PAYMENT\]\]([\s\S]*?)\[\[\/E_PAYMENT\]\]/g,
						'',
					);
				}
			}
			return text;
		},
		fetchTags() {
			const params = {
				limit: 120,
				sort_by: 'name',
				sort: 'desc',
				page: 1,
				category: 'order',
			};
			this.getSubmissionTags(params);
		},
		fetchStatistic() {
			// Fetch Statistic
			const statisticParams = duplicateVar(this.fetchParams);
			delete statisticParams.status;
			this.$store.dispatch('fetchStatistic', statisticParams);
		},
		fetchFollowUpConversionStatistic() {
			// Fetch Statistic
			this.$store.dispatch(
				'fetchFollowUpConversionStatistic',
				this.fetchParams,
			);
		},
		fetchTrackingStatistic() {
			// Fetch Statistic
			this.$store.dispatch('fetchTrackingStatistic', this.fetchParams);
		},
		fetchDailyStatistic() {
			// Fetch Daily Statistic
			this.$store.dispatch('fetchDailyStatistic', this.fetchParams);
		},
		fetchCustomerStatistic() {
			// Fetch Daily Statistic
			this.$store.dispatch('fetchCustomerStatistic', this.fetchParams);
		},
		fetchSubmissions(reset = true) {
			if (reset) {
				this.resetSubmissions();
			}
			// Fetch Submissions
			this.$store.dispatch('submissions/getSubmissions', this.fetchParams);
		},
		fetchNewOrders() {
			this.resetFilters();
			this.resetNewOrders();
			this.fetchSubmissions(true);
		},
		clearFilters() {
			// Status
			this.selectedStatus = [];

			// Payment Status
			this.selectedPaymentStatus = null;

			// Coupon Code
			this.selectedCouponCode = '';

			// Processing Date
			// this.filterProcessingDate = '';
			this.filterProcessingAtSince = '';
			this.filterProcessingAtUntil = '';

			// Completed Date
			this.filterCompletedSince = '';
			this.filterCompletedUntil = '';

			// Handled By
			// this.selectedMember = null;
			this.selectedMember = [];

			// reseller

			this.selectedFilterReseller = [];

			// Tags
			this.filterTags = [];

			// Packing Slip
			this.selectedPackingSlip = null;

			// Pickup Status
			this.filterPickup = null;

			// Advanced Filters
			this.filters = duplicateVar(defaultAdvancedFilters);

			this.submissionIds = [];
			this.returnStatus = null;
		},
		resetFilterDate() {
			this.filterDate = duplicateVar(defaultFilterDate);
			if (this.$refs.datePicker) {
				this.$refs.datePicker.checkDefaultPresets();
			}
		},
		resetFilters() {
			this.$router.push('/orders');
			setTimeout(() => {
				this.resetNewOrders();
				this.clearFilters();
				this.resetFilterDate();
				this.resetPickupAddress();
				this.fetchData(true);
			}, 500);
		},
		resetPickupAddress() {
			this.selectedProvince = {};
			this.selectedCity = {};
			this.selectedSubdistrict = {};
		},
		fetchProducts() {
			// Fetch Products List
			this.getProducts();
		},
		fetchMembers() {
			const params = {
				limit: 1000,
				sort_by: 'created_at',
				sort: 'desc',
				page: 1,
				keyword: '',
			};
			this.getMembers(params);
		},
		fetchForms(productId) {
			this.getForms(productId);
		},
		fetchData(reset = true) {
			this.fetchSubmissions(reset);
			this.fetchStatistic();
			if (this.showStats) {
				this.fetchMoreStats();
			}
		},
		fetchMoreStats() {
			this.fetchFollowUpConversionStatistic();
			this.fetchTrackingStatistic();
			this.fetchDailyStatistic();
			this.fetchCustomerStatistic();
		},
		fetchAll() {
			this.fetchProducts();
			if (this.teamMembers.length === 0) {
				this.fetchMembers();
			}
			this.fetchData();
		},
		init() {
			if (this.submissionIdsParam) {
				this.submissionIds = this.submissionIdsParam;
			}
			this.checkCapabilities();
			this.setShipperOrderStatus();
			this.initColumns();
			this.initFilterDate();
			this.fetchAll();
			this.toggleFilterResellerOrder();
			if (this.provinces.length === 0) {
				this.fetchProvinces();
			}
			// this.initLogo();
			// this.fetchTags();
		},
		// Set Shipper Order Status
		setShipperOrderStatus() {
			const isStatusEmpty = !this.status || this.status === '';
			if (isStatusEmpty && this.user.role === 'shipper') {
				const query = duplicateVar(this.$route.query);
				if (!query.status) {
					query.status = 'processing';
					const params = { query };
					this.$router.push(params);
				}
				this.selectedStatus = ['Processing'];
			}
		},
		showMarkPending(submission) {
			this.checkPaymentStatus(submission, 'pending');
			this.selectedSubmission = submission;
			this.isShowMarkPending = true;
		},
		hideMarkPending() {
			this.isShowMarkPending = false;
			this.selectedSubmission = null;
		},
		showMarkProcessing(submission) {
			this.checkPaymentStatus(submission, 'processing');
			this.selectedSubmission = submission;
			this.isShowMarkProcessing = true;
		},
		hideMarkProcessing() {
			this.isShowMarkProcessing = false;
			this.selectedSubmission = null;
		},
		showMarkComplete(submission) {
			this.checkPaymentStatus(submission, 'completed');
			this.selectedSubmission = submission;
			this.isShowMarkComplete = true;
		},
		hideMarkComplete() {
			this.isShowMarkComplete = false;
			this.selectedSubmission = null;
		},
		showMarkRefund(submission) {
			this.checkPaymentStatus(submission, 'refund');
			this.selectedSubmission = submission;
			this.isShowMarkRefund = true;
		},
		hideMarkRefund() {
			this.isShowMarkRefund = false;
			this.selectedSubmission = null;
		},
		showMarkCancel(submission) {
			this.checkPaymentStatus(submission, 'cancelled');
			this.selectedSubmission = submission;
			this.isShowMarkCancel = true;
		},
		hideMarkCancel() {
			this.isShowMarkCancel = false;
			this.selectedSubmission = null;
		},
		showMarkPaid(submission) {
			this.selectedSubmission = submission;
			this.isShowMarkPaid = true;
		},
		showMarkUnpaid(submission) {
			this.selectedSubmission = submission;
			this.isShowMarkUnpaid = true;
		},
		hideProcessOrders() {
			this.isShowProcessOrders = false;
			// this.selectedSubmission = null;
		},
		checkPaymentStatus(order, status) {
			const paymentMethod =				order.payment && order.payment.method
				? order.payment.method
				: 'bank_transfer';
			let paymentStatus = 'paid';
			if (status === 'processing') {
				if (paymentMethod === 'bank_transfer') {
					paymentStatus = 'paid';
				} else if (paymentMethod === 'cod') {
					paymentStatus = 'unpaid';
				}
			} else if (status === 'completed') {
				if (paymentMethod === 'bank_transfer') {
					paymentStatus = 'paid';
				} else if (paymentMethod === 'cod') {
					paymentStatus = 'paid';
				}
			} else if (status === 'pending' || status === 'cancelled') {
				paymentStatus = 'unpaid';
			}
			this.paymentStatus = paymentStatus;
		},
		setStatus(submission, status) {
			this.isChangingStatus = true;

			const submissionId = submission._id;
			const params = { status };

			if (status === 'completed') {
				params.receipt_number = this.receiptNumber;
			}

			const paymentStatus = this.paymentStatus;
			const paymentMethod = submission?.payment?.method ?? 'bank_transfer';
			const isInstant = paymentMethod === 'instant';

			const isUserCanUpdatePaymentStatus =				(paymentStatus === 'paid' && this.isUserCanPaid)
				|| (paymentStatus === 'unpaid' && this.isUserCanUnpaid);

			const allowedStatus = ['pending', 'processing', 'completed', 'cancelled'];
			const isAddPaymentStatus =				isUserCanUpdatePaymentStatus
				&& allowedStatus.includes(status)
				&& !isInstant;

			if (isAddPaymentStatus) {
				params.payment_status = paymentStatus;
			}

			// Update Progress
			const callback = () => {
				const payload = {
					id: submissionId,
					status,
				};

				if (status === 'completed') {
					payload.receiptNumber = duplicateVar(this.receiptNumber);
					this.receiptNumber = '';
				}

				if (isAddPaymentStatus) {
					payload.paymentStatus = paymentStatus;
				}

				this.changeStatus(payload);

				this.isChangingStatus = false;
				// this.hideMarkComplete();
				this.isShowMarkPending = false;
				this.isShowMarkProcessing = false;
				this.isShowMarkComplete = false;
				this.isShowMarkCancel = false;
				this.isShowMarkRefund = false;

				this.selectedSubmission = null;

				// Track
				const orderId = submission.order_id;
				const trackData = {
					order_id: orderId,
					status,
					receipt_number: params.receipt_number,
					payment_status: params.payment_status,
				};
				this.$track('order-update-status', trackData);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isChangingStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setStatus(submissionId, params, callback, errorCallback);
		},
		setPaymentStatus(submission, status) {
			this.isUpdatingPaymentStatus = true;

			const submissionId = submission._id;
			const params = { payment_status: status };

			// Update Progress
			const callback = () => {
				const payload = {
					id: submissionId,
					status,
				};
				this.changePaymentStatus(payload);
				this.isUpdatingPaymentStatus = false;
				this.isShowMarkPaid = false;
				this.isShowMarkUnpaid = false;
				this.selectedSubmission = null;

				// Track
				const orderId = submission.order_id;
				const trackData = {
					order_id: orderId,
					payment_status: status,
				};
				this.$track('order-update-payment', trackData);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isUpdatingPaymentStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Payment Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setPaymentStatus(
				submissionId,
				params,
				callback,
				errorCallback,
			);
		},
		onRefunded(submission) {
			this.setStatus(submission, 'refunded');
			// Don't change payment status if E-Payment (instant)
			const paymentMethod = submission?.payment?.method ?? 'bank_transfer';
			if (paymentMethod !== PAYMENT_METHOD_INSTANT) {
				this.setPaymentStatus(submission, 'unpaid');
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = this.moment(filterDate.start).format('YYYY-MM-DD');
			const until = this.moment(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchData();
			this.fetchStatsCustomerCredit();
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				// self.fetchSubmissions();
				self.fetchData();
			}, 1000);
		},
		bulkDelete() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selected.length; i++) {
					const id = this.selected[i];
					const index = this.submissions.findIndex(
						submission => submission._id === id,
					);
					const isIndex = index !== -1;
					if (isIndex) {
						this.delete(index);
					}

					// Delete from selected submissions
					const selectedIndex = this.selectedSubmissions.findIndex(
						currSub => currSub._id === id,
					);
					if (selectedIndex !== -1) {
						this.selectedSubmissions.splice(selectedIndex, 1);
					}
				}
				this.$set(this, 'selected', []);
				this.selectedOrderIds = [];

				this.isShowDeleteOrderBulk = false;
				this.$notify({
					group: 'orders',
					title: 'Orders',
					text: 'Orders deleted',
					type: 'success',
				});
			};
			submissionsApi.bulkDelete(this.selected.slice(), callback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchSubmissions(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchSubmissions(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		showDetails(submission, event) {
			event.preventDefault();
			this.selectedSubmission = submission;
			this.isShowDetails = true;
		},
		hideDetails() {
			this.isShowDetails = false;
			this.selectedSubmission = null;
		},
		exportOrders(type) {
			this.isExporting = true;
			// const dateFormat = 'YYYY-MM-DD';
			// const startDate = this.moment(this.filterDate.start).format(dateFormat);
			// const endDate = this.moment(this.filterDate.end).format(dateFormat);
			// const productId = this.productId ? this.productId : 0;
			// const params = {
			// 	sort_by: this.sort_by,
			// 	sort: this.sort,
			// 	keyword: this.filterKeyword,
			// 	file_type: type,
			// 	product_id: productId,
			// 	form_id: this.formId,
			// 	since: startDate,
			// 	until: endDate,
			// 	status: this.status,
			// 	coupon: this.selectedCouponCode,
			// };
			// if (this.processingAt && this.processingAt !== '') {
			// 	params.processing_at = this.processingAt;
			// }
			const params = duplicateVar(this.fetchParams);
			params.file_type = type;
			const callback = (response) => {
				this.isExporting = false;
				// const file = response.data;
				// const files = file.split('/');
				// const fileDir = `${files[0]}/${files[1]}`;
				// const fileName = files[2];
				// const fileNameEncoded = encodeURIComponent(fileName);
				// const path = `${fileDir}/${fileNameEncoded}`;
				// const prefix = 'https://api.ostock.id';
				// const url = `${prefix}/${path}`;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			submissionsApi.export(params, callback, errorCallback);
		},
		printInvoice() {
			this.isPrinting = true;
			const orderId = this.selectedSubmission.order_id;
			const timestamp = new Date().getTime();
			const name = `Invoice-${orderId}-${timestamp}`;
			const callback = () => {
				this.isPrinting = false;
			};
			setTimeout(() => {
				makePDF(document, 'invoice', html2canvas, jsPDF, name, callback);
			}, 300);
		},
		filterResellerOrder(val = true) {
			if (val) {
				const cs = { _id: 'all', name: 'All' };
				this.$set(this, 'selectedFilterReseller', [cs]);
				this.applyFilter();
			} else {
				this.$set(this, 'selectedFilterReseller', []);
				this.applyFilter();
			}
		},
		// Apply Filter
		applyFilter() {
			this.selected = [];
			this.selectedSubmissions = [];
			this.selectedOrderIds = [];

			const status = this.selectedStatus.join(',').toLowerCase();
			const province = this.selectedProvince;
			const city = this.selectedCity;
			const subdistrict = this.selectedSubdistrict;
			const paymentStatus = this.selectedPaymentStatus;
			const paymentMethod = this.selectedPaymentMethod;
			const couponCode = this.selectedCouponCode;
			const processingDate = this.filterProcessingDate;
			const dateSince = this.filterProcessingAtSince;
			const dateUntil = this.filterProcessingAtUntil;
			const completedSince = this.filterCompletedSince;
			const completedUntil = this.filterCompletedUntil;
			const paidSince = this.filterPaidSince;
			const paidUntil = this.filterPaidUntil;
			const query = duplicateVar(this.$route.query);
			const teamMember = this.selectedMember.map(el => el._id);
			const teamMembers = teamMember.join(',').toLowerCase();
			const filterTag = this.filterTags.map(el => el.name);
			const tags = filterTag.join(',').toLowerCase();
			const packingSlip = this.selectedPackingSlip;
			const receiptNumber = this.filterReceiptNumber;
			const bumpStatus = this.selectedBumpStatus;
			const pickupStatus = this.filterPickup;
			const courier = this.filterCourier;
			const reseller = this.selectedFilterReseller.map(el => el._id);
			const resellers = reseller.join(',').toLowerCase();

			if (province) {
				query.province = province.province_name;
			} else {
				delete query.province;
			}

			if (city) {
				query.city = city.city_name_with_type;
			} else {
				delete query.city;
			}
			if (subdistrict) {
				query.subdistrict = subdistrict.subdistrict_name;
			} else {
				delete query.subdistrict;
			}

			// Status
			if (status !== '') {
				query.status = status;
			} else {
				delete query.status;
			}

			// Payment Status
			if (paymentStatus && paymentStatus.key !== 'all') {
				query.payment_status = paymentStatus.key;
			} else {
				delete query.payment_status;
			}

			// Payment Method
			if (paymentMethod && paymentMethod.key !== 'all') {
				query.payment_method = paymentMethod.key;
			} else {
				delete query.payment_method;
			}

			// Bump
			if (bumpStatus && bumpStatus.key !== 'all') {
				query.bump = bumpStatus.key;
			} else {
				delete query.bump;
			}

			// Coupon Code
			if (couponCode && couponCode !== '') {
				query.coupon = couponCode;
			} else {
				delete query.coupon;
			}

			// Reseller
			if (resellers) {
				query.reseller_ids = resellers;
			} else {
				delete query.reseller_ids;
			}

			// Processing Date
			if (processingDate && processingDate !== '') {
				query.processing_at = processingDate;
			} else {
				delete query.processing_at;
			}

			// Team Member
			// if (teamMember) {
			// 	query.member = teamMember._id;
			// } else {
			// 	delete query.member;
			// }

			if (teamMembers) {
				query.member = teamMembers;
			} else {
				delete query.member;
			}

			// Processing Date
			if (dateSince && dateSince !== '' && dateUntil && dateUntil !== '') {
				query.processing_at_since = dateSince;
				query.processing_at_until = dateUntil;
			} else {
				delete query.processing_at_since;
				delete query.processing_at_until;
			}

			// Completed Date
			if (
				completedSince
				&& completedSince !== ''
				&& completedUntil
				&& completedUntil !== ''
			) {
				query.completed_at_since = completedSince;
				query.completed_at_until = completedUntil;
			} else {
				delete query.completed_at_since;
				delete query.completed_at_until;
			}

			// Paid Date
			if (paidSince && paidSince !== '' && paidUntil && paidUntil !== '') {
				query.paid_at_since = paidSince;
				query.paid_at_until = paidUntil;
			} else {
				delete query.paid_at_since;
				delete query.paid_at_until;
			}

			// Tag
			if (tags && tags !== '') {
				query.tags = tags;
			} else {
				delete query.tags;
			}

			// Packing slip
			if (packingSlip && packingSlip.key !== 'all') {
				query.is_printed = packingSlip.key;
			} else {
				delete query.is_printed;
			}

			// Receipt Number
			if (receiptNumber && receiptNumber !== '') {
				query.receipt_number = receiptNumber;
			} else {
				delete query.receipt_number;
			}

			// // Processing Date
			// if (processingDate && processingDate !== '') {
			// 	query.processing_at = processingDate;
			// } else {
			// 	delete query.processing_at;
			// }

			// Courier
			if (courier && courier.key !== 'all') {
				query.courier = courier.key;
			} else {
				delete query.courier;
			}

			// Pickup
			if (pickupStatus && pickupStatus.key !== 'all') {
				query.pickup = pickupStatus.key;
			} else {
				delete query.pickup;
			}

			// Advanced Filters
			const filterKeys = Object.keys(this.filters);
			for (let index = 0; index < filterKeys.length; index++) {
				const key = filterKeys[index];
				const filter = this.filters[key];
				if (filter !== '') {
					query[key] = filter;
				} else {
					delete query[key];
				}
			}

			const params = { query };
			this.$router.push(params);
			this.isShowFilter = false;

			// this.fetchSubmissions(true);
			// this.fetchData(true);
			setTimeout(() => {
				this.fetchData(true);
			}, 100);
		},
		printPackingSlips() {
			this.isPrintingPackingSlips = true;
			const timestamp = new Date().getTime();
			const name = `Packing-Slip-${timestamp}`;
			const callback = () => {
				this.isPrintingPackingSlips = false;
			};
			setTimeout(() => {
				makePDF(document, 'packing-slips', html2canvas, jsPDF, name, callback);
			}, 400);
		},
		checkCapabilities() {
			if (!this.isUserCan('order_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		isShowColumn(key) {
			return this.columns.includes(key);
		},
		saveColumns() {},
		initColumns() {
			this.selectedColumns = duplicateVar(this.columns);
		},
		resetColumns() {
			this.initColumns();
			this.isShowCustomColumns = false;
		},
		applySelectedColumns(value) {
			this.selectedColumns = value;
			this.applyColumns();
		},
		applyColumns() {
			const columns = duplicateVar(this.selectedColumns);
			const columnsString = columns.join(',');
			const query = duplicateVar(this.$route.query);
			query.columns = columnsString;
			this.$router.push({ name: 'submissions', query });
			this.isShowCustomColumns = false;
			const callback = () => this.fetchUser();
			userApi.udpateOrdersColumns(columns, callback);
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user.timezone;
			// const formattedDate = this.moment.utc(dateString).local().format(format);
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		getTeamMember(submission) {
			const isHaveBelongsTo =				submission.belongs_to && submission.belongs_to.length;
			const memberId = isHaveBelongsTo > 0 ? submission.belongs_to[0].$oid : 0;
			return this.teamMembers.find(member => member._id === memberId);
		},
		getTeamMemberName(submission) {
			const teamMember = this.getTeamMember(submission);
			return teamMember ? teamMember.name : '';
		},
		getPaymentInfo(submission) {
			return getPaymentInfo(submission);
		},
		getMeta(submission, key) {
			const meta = submission.meta || {};
			const value = meta[key] || '';
			return value;
		},
		initLogo() {
			let url = this.store ? this.store.logo : false;
			url = url.replace('https://cdn.orderonline.id', s3Url);
			if (url && url !== '') {
				const callback = (image) => {
					this.logo = image;
				};
				imageURLtoBase64(url, callback);
			}
		},
		onLogoLoaded() {
			this.initLogo();
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? this.moment(this.sinceQuery)
				: this.moment(dateRange.start);
			const untilDate = hasUntilQuery
				? this.moment(this.untilQuery)
				: this.moment(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		showEditOrder(order) {
			this.selectedSubmission = order;
			this.isShowEdit = true;
		},
		hideEdit() {
			this.isShowEdit = false;
			this.selectedSubmission = null;
		},
		updateOrder(order) {
			this.updateSubmission(order);
			// Update Selected
			const index = this.selectedSubmissions.findIndex(
				currSub => currSub._id === order._id,
			);
			if (index !== -1) {
				// this.selectedSubmissions[index] = order;
				this.$set(this.selectedSubmissions, index, order);
			}
		},
		updateCustomer(order) {
			this.updateSubmissionCustomer(order);
			// Update Selected
			const index = this.selectedSubmissions.findIndex(
				currSub => currSub._id === order._id,
			);
			const updatedCustomerData = order.customer_data;
			if (index !== -1) {
				const submission = duplicateVar(this.selectedSubmissions[index]);
				const currentCustomerData = submission.customer_data;
				const newCustomerData = Object.assign(
					{},
					currentCustomerData,
					updatedCustomerData,
				);
				submission.customer_data = newCustomerData;
				this.$set(this.selectedSubmissions, index, submission);
			}
		},
		checkListTable() {
			const ordersList = document.getElementById('orders-list');
			if (ordersList) {
				const ordersListVerticalScroll = document.getElementById(
					'orders-list-vertical-scroll',
				);
				const documentHeight = document.documentElement.clientHeight;
				const scrollTop = document.documentElement.scrollTop;
				const ordersListHeight = ordersList.offsetHeight;
				const offsetTop = ordersList.offsetTop;
				const offsetBottom = offsetTop + ordersListHeight;
				const scrollBottom = offsetBottom - scrollTop;
				const topTreshold = 100;
				const scrollTreshold = offsetTop - (documentHeight - topTreshold);
				const display =					scrollTop >= scrollTreshold && scrollBottom >= documentHeight
					? 'block'
					: 'none';
				ordersListVerticalScroll.style.display = display;
			}
		},
		onDocumentScroll(event) {
			if (event.target === document) {
				this.checkListTable();
			} else if (event.target.id === 'orders-list') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersListVerticalScroll = document.getElementById(
					'orders-list-vertical-scroll',
				);
				ordersListVerticalScroll.scrollLeft = scrollLeft;
			} else if (event.target.id === 'orders-list-vertical-scroll') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersList = document.getElementById('orders-list');
				ordersList.scrollLeft = scrollLeft;
			}
		},
		setVerticalScroll() {
			const ordersList = document.getElementById('orders-list');
			if (ordersList) {
				const ordersListTable = document.getElementById('orders-list-table');
				const ordersListVerticalScroll = document.getElementById(
					'orders-list-vertical-scroll',
				);
				const ordersListVerticalScrollContent = document.getElementById(
					'orders-list-vertical-scroll-content',
				);
				const listWidth = ordersList.offsetWidth;
				const listLeft = ordersList.offsetLeft;
				const tableWidth = ordersListTable.offsetWidth;
				ordersListVerticalScroll.style.width = `${listWidth}px`;
				ordersListVerticalScroll.style.left = `${listLeft}px`;
				ordersListVerticalScrollContent.style.width = `${tableWidth}px`;
			}
		},
		getQuantity(order) {
			let quantity = 1;
			if (order.type === 'storefront') {
				quantity = order.cart_items.reduce(
					(total, cartItem) => total + cartItem.qty,
					0,
				);
			} else {
				quantity = order.customer_data.quantity || 1;
				if (order.customer_data.variations) {
					quantity = order.customer_data.variations.reduce(
						(accumulator, variation) => {
							const variationQuantity = variation.quantity || 1;
							return accumulator + variationQuantity;
						},
						0,
					);
				}
			}
			return quantity;
		},
		copy(str) {
			copyToClipboard(str);
			this.$notify({
				group: 'orders',
				title: 'Receipt Number',
				text: 'Successfully Copied',
				type: 'success',
			});
		},
		initAdvancedFilter() {
			this.filters.utm_source = this.utmSource || '';
			this.filters.utm_medium = this.utmMedium || '';
			this.filters.utm_campaign = this.utmCampaign || '';
			this.filters.utm_term = this.utmTerm || '';
			this.filters.utm_content = this.utmContent || '';
		},
		selectReceiptFle(event) {
			const target = event.target;
			const files = target.files;
			this.receiptFile = files[0];
		},
		uploadReceipt() {
			this.isUploadingReceipt = true;
			const formData = new FormData();
			const file = this.receiptFile;
			const status = this.uploadReceiptStatus;
			formData.append('file', file);
			formData.append('status', status);
			const callback = (response) => {
				const orders = response.data;
				this.updateOrderReceipts({ orders, status });
				this.isUploadReceiptVisible = false;
				this.isUploadingReceipt = false;
				this.$notify({
					group: 'orders',
					title: 'Receipt Numbers',
					text: 'Order receipt numbers has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUploadingReceipt = false;
			};
			submissionsApi.uploadReceipt(formData, callback, errorCallback);
		},
		openModalTag(type, id) {
			let data = null;
			if (type === 'single') {
				data = this.submissions.filter(el => el._id === id);
			} else {
				data = this.selectedSubmissions;
			}
			this.isShowTag = !this.isShowTag;
			this.tagType = type;
			this.tagData = data;
		},
		renderTag(val, length, index) {
			let html = `${val}, `;
			if (index === length - 1) html = val;
			return html;
		},
		checkFilterMembers() {
			const members =				this.member && this.member !== '' ? this.member.split(',') : [];

			const teamMembers = this.teamMembers.filter(({ _id }) => members.includes(_id));
			// const teamMembers = members.map((id) => {
			// 	const member = this.teamMembers.find(el => el._id === id);
			// 	return member;
			// });

			if (teamMembers.length > 0) {
				this.selectedMember = teamMembers;
			}
		},
		checkFilterResellerIds() {
			const members =				this.resellerIds && this.resellerIds !== ''
				? this.resellerIds.split(',')
				: [];

			const teamMembers = this.filterResellerIds.filter(({ _id }) => members.includes(_id));
			// const teamMembers = members.map((id) => {
			// 	const member = this.teamMembers.find(el => el._id === id);
			// 	return member;
			// });

			if (teamMembers.length > 0) {
				this.selectedFilterReseller = teamMembers;
			}
		},
		showBulkStatusUpdate(status) {
			// const orderIds = this.selected.map((id) => {
			// 	const subId = this.submissions.find(el => el._id === id);
			// 	return subId.order_id;
			// });
			const filter = (order) => {
				const index = this.selected.findIndex(id => id === order._id);
				return index !== -1;
			};
			const filteredOrders = this.submissions.filter(filter);
			const orderIds = filteredOrders.map(order => order.order_id);
			this.isShowBulkUpdateStatus = true;
			this.bulkUpdateStatus = status;
			this.selectedOrderIds = orderIds;
		},
		setBulkStatus() {
			this.isChangingStatus = true;

			const params = {
				order_ids: JSON.stringify(this.selectedOrderIds),
				status: this.bulkUpdateStatus,
			};

			let paymentStatus = duplicateVar(this.bulkPaymentStatus);
			if (
				this.bulkUpdateStatus === 'cancelled'
				|| this.bulkUpdateStatus === 'refunded'
			) {
				paymentStatus = 'unpaid';
			}

			const isUserCanUpdatePaymentStatus = (paymentStatus === 'paid' && this.isUserCanPaid)
				|| (paymentStatus === 'unpaid' && this.isUserCanUnpaid);

			const allowedStatus = [
				'processing',
				'completed',
				'refunded',
				'cancelled',
			];
			const isAddPaymentStatus = isUserCanUpdatePaymentStatus
				&& allowedStatus.includes(this.bulkUpdateStatus);

			if (isAddPaymentStatus) {
				params.payment_status = paymentStatus;
			}

			// Update Progress
			const callback = () => {
				const payload = {
					ids: this.selectedOrderIds,
					status: this.bulkUpdateStatus,
				};

				if (isAddPaymentStatus) {
					// let paymentStatus = this.bulkPaymentStatus;
					// Check if refunded, then change the payment status to unpaid
					// if (this.bulkUpdateStatus === 'refunded') {
					// 	paymentStatus = 'unpaid';
					// }
					payload.paymentStatus = paymentStatus;
				}

				this.updateBulkStatus(payload);

				this.isChangingStatus = false;
				this.bulkPaymentStatus = 'paid';
				this.bulkUpdateStatus = '';
				this.isShowBulkUpdateStatus = false;
				this.selected = [];
				this.selectedOrderIds = [];
				this.selectedSubmissions = [];

				// Track
				const trackData = {
					ids: params.ids,
					status: params.status,
					payment_status: params.payment_status,
				};
				this.$track('order-bulk-status', trackData);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isChangingStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setBulkStatus(params, callback, errorCallback);
		},
		setBulkPaymentStatus(status) {
			this.isChangingStatus = true;
			this.bulkPaymentStatus = status;

			const params = {
				order_ids: JSON.stringify(this.selectedOrderIds),
				payment_status: this.bulkPaymentStatus,
			};

			// Update Progress
			const callback = () => {
				const payload = {
					ids: this.selectedOrderIds,
					paymentStatus: this.bulkPaymentStatus,
				};

				this.updateBulkPaymentStatus(payload);

				this.isChangingStatus = false;
				this.bulkPaymentStatus = 'paid';
				this.bulkUpdateStatus = '';
				this.isShowBulkUpdateStatus = false;
				this.selected = [];
				this.selectedOrderIds = [];
				this.selectedSubmissions = [];

				// Track
				const trackData = {
					ids: params.ids,
					payment_status: params.payment_status,
				};
				this.$track('order-bulk-payment', trackData);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isChangingStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setBulkPaymentStatus(params, callback, errorCallback);
		},
		assignTeam() {
			this.isApplyingAssignTeam = true;
			const filter = (order) => {
				const index = this.selected.findIndex(id => id === order._id);
				return index !== -1;
			};
			const filteredOrders = this.submissions.filter(filter);
			const orderIds = filteredOrders.map(order => order.order_id);

			const params = {
				order_ids: JSON.stringify(orderIds),
				team_member_id: this.selectedTeam._id,
			};

			// Update Progress
			const callback = (response) => {
				const payload = {
					ids: orderIds,
					team: { $oid: this.selectedTeam._id },
				};
				this.updateAssignTeam(payload);
				this.isShowAssignTeam = false;
				this.isApplyingAssignTeam = false;
				this.$notify({
					group: 'orders',
					title: 'Order Team',
					text: response.message,
					type: 'success',
				});
				this.selectedTeam = [];
				this.selected = [];
				this.selectedOrderIds = [];
				this.selectedSubmissions = [];
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isShowAssignTeam = false;
				this.isApplyingAssignTeam = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setAssignToTeam(params, callback, errorCallback);
		},
		getCourierLabel(key) {
			const courier = shippingCouriers.find(courier => courier.key === key);
			const label = courier ? courier.label : key;
			return label;
		},
		customerDataVariations(val, multiple) {
			return generateVariationsData(val, multiple);
		},
		checkFilters() {
			if (!this.productId) {
				this.selectedProduct = defaultProduct;
			} else {
				// Fetch Forms
				this.fetchForms(this.productId);
			}
			if (this.formId === 0) {
				this.selectedForm = defaultForm;
			}
			if (this.status !== '') {
				const statuses = this.status.split(',');
				const selectedStatus = statuses.map(status => toTitleCase(status));
				this.selectedStatus = selectedStatus;
			}
			if (this.couponCode !== '') {
				this.selectedCouponCode = this.couponCode;
			}
			if (this.processingAt !== '') {
				this.filterProcessingDate = this.processingAt;
			}
			if (this.processingAtSinceQuery) {
				this.filterProcessingAtSince = this.processingAtSinceQuery;
			}
			if (this.processingAtUntilQuery) {
				this.filterProcessingAtUntil = this.processingAtUntilQuery;
			}
			if (this.completedSinceQuery) {
				this.filterCompletedSince = this.completedSinceQuery;
			}
			if (this.completedUntilQuery) {
				this.filterCompletedUntil = this.completedUntilQuery;
			}
			if (this.completedSinceQuery) {
				this.filterCompletedSince = this.completedSinceQuery;
			}
			if (this.completedUntilQuery) {
				this.filterCompletedUntil = this.completedUntilQuery;
			}
			if (this.paidSinceQuery) {
				this.filterPaidSince = this.paidSinceQuery;
			}
			if (this.paidUntilQuery) {
				this.filterPaidUntil = this.paidUntilQuery;
			}
			if (this.member && this.member !== '' && this.teamMembers.length > 0) {
				this.checkFilterMembers();
			}
			if (this.tags && this.tags !== '') {
				const tags = this.tags.split(',');
				const selected = tags.map((item) => {
					const newItem = { name: item };
					return newItem;
				});
				this.filterTags = selected;
			}
			if (this.paymentStatusQuery && this.paymentStatusQuery !== '') {
				const paymentStatus = paymentStatuses.find(
					payment => payment.key === this.paymentStatusQuery,
				);
				if (paymentStatus) {
					this.selectedPaymentStatus = paymentStatus;
				}
			}
			if (this.filterResellerQuery && this.filterResellerQuery !== '') {
				const resellerIds = this.filterResellerQuery.split(',');
				resellerIds.forEach((resellerId, index) => {
					const filterReseller = this.resellerOptions.find(
						reseller => reseller._id === resellerId,
					);
					if (filterReseller) {
						this.selectedFilterReseller[index] = filterReseller;
					}
				});
			}
			if (this.bumpQuery && this.bumpQuery !== '') {
				const bumpStatus = this.bumpStatuses.find(
					bump => bump.key === this.bumpQuery,
				);
				if (bumpStatus) {
					this.selectedBumpStatus = bumpStatus;
				}
			}
			if (this.paymentMethodQuery && this.paymentMethodQuery !== '') {
				const paymentMethod = this.paymentMethods.find(
					({ key }) => key === this.paymentMethodQuery,
				);
				if (paymentMethod) {
					this.selectedPaymentMethod = paymentMethod;
				}
			}
			if (this.packingSlipQuery && this.packingSlipQuery !== '') {
				const packingSlip = this.packingSlips.find(
					cur => cur.key === parseInt(this.packingSlipQuery),
				);
				if (packingSlip) {
					this.selectedPackingSlip = packingSlip;
				}
			}
			if (this.receiptNumberQuery && this.receiptNumberQuery !== '') {
				this.filterReceiptNumber = duplicateVar(this.receiptNumberQuery);
			}
			if (this.pickupQuery && this.pickupQuery !== '') {
				const pickupStatus = this.pickupStatuses.find(
					({ key }) => key === this.pickupQuery,
				);
				if (pickupStatus) {
					this.filterPickup = pickupStatus;
				}
			}
			if (this.courierQuery && this.courierQuery !== '') {
				const courier = this.couriersOptions.find(
					({ key }) => key === this.courierQuery,
				);
				if (courier) {
					this.filterCourier = courier;
				}
			}
		},
		formatTitle(str) {
			const title = str.replace(/_/g, ' ');
			return toTitleCase(title);
		},
		getCity(customerData) {
			const city = customerData.city_name || customerData.city;
			return city;
		},
		showProcessOrders() {
			const filteredOrders = this.selectedPendingOrders;
			const filteredSelected = filteredOrders.map(order => order._id);
			this.selected = filteredSelected;
			this.selectedOrderIds = filteredOrders.map(order => order.order_id);

			if (this.selectedOrderIds.length > 0) {
				this.isShowProcessOrders = true;
				this.bulkUpdateStatus = 'processing';
			}
		},
		processOrders() {
			this.bulkPaymentStatus = 'unpaid';

			this.isChangingStatus = true;

			const params = {
				order_ids: JSON.stringify(this.selectedOrderIds),
				status: this.bulkUpdateStatus,
			};

			const paymentStatus = duplicateVar(this.bulkPaymentStatus);

			// disable update payment status
			// const isUserCanUpdatePaymentStatus = (paymentStatus === 'paid' && this.isUserCanPaid) || (paymentStatus === 'unpaid' && this.isUserCanUnpaid);

			// const allowedStatus = [
			// 	'processing',
			// 	'completed',
			// 	'refunded',
			// 	'cancelled',
			// ];
			// const isAddPaymentStatus = isUserCanUpdatePaymentStatus
			// 	&& allowedStatus.includes(this.bulkUpdateStatus);
			const isAddPaymentStatus = false;

			if (isAddPaymentStatus) {
				params.payment_status = paymentStatus;
			}

			// Update Progress
			const callback = () => {
				const payload = {
					ids: this.selectedOrderIds,
					status: this.bulkUpdateStatus,
				};

				if (isAddPaymentStatus) {
					payload.paymentStatus = paymentStatus;
				}

				this.updateBulkStatus(payload);

				this.isChangingStatus = false;
				this.bulkPaymentStatus = 'paid';
				this.bulkUpdateStatus = '';
				this.isShowProcessOrders = false;
				this.showPackingSlip();
				// this.selected = [];
				this.selectedOrderIds = [];
				// this.selectedSubmissions = [];

				// Track
				const trackData = {
					ids: params.ids,
					status: params.status,
					payment_status: params.payment_status,
				};
				this.$track('order-bulk-status', trackData);
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isChangingStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			submissionsApi.setBulkStatus(params, callback, errorCallback);
		},
		showPackingSlip() {
			this.fetchProductCodes(this.selectedSubmissions);
			this.fetchLabelDataSource(this.selectedSubmissions);
			const jxOrders = this.selectedSubmissions.filter(({ shipping }) => shipping.courier === 'jx');
			const isNeedLabelData = jxOrders.length > 0;
			if (isNeedLabelData) {
				this.fetchLabelData(jxOrders);
			} else {
				// this.isShowPackingSlip = true;
			}
		},
		fetchLabelData(orders) {
			this.labelsFetchingStatus.push('label');
			// this.isFetchingLabel = true;
			// eslint-disable-next-line camelcase
			const mapper = ({ order_id, shipping }) => ({ order_id, receipt_number: shipping.receipt_number });
			const formattedOrders = orders.map(mapper);
			const params = {
				orders: JSON.stringify(formattedOrders),
			};
			const callback = (response) => {
				const labels = response.data;
				this.labels = labels;
				// this.isFetchingLabel = false;
				const index = this.labelsFetchingStatus.findIndex(status => status === 'label');
				if (index !== -1) {
					this.labelsFetchingStatus.splice(index, 1);
				}
				if (this.labelsFetchingStatus.length === 0) {
					this.isShowPackingSlip = true;
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				// this.isFetchingLabel = false;
				const index = this.labelsFetchingStatus.findIndex(status => status === 'label');
				if (index !== -1) {
					this.labelsFetchingStatus.splice(index, 1);
				}
			};
			receiptNumbesrApi.getLabelData(params, callback, errorCallback);
		},
		fetchLabelDataSource(orders) {
			this.submissionsLabels = [];
			// this.isFetchingLabel = true;
			const callback = (response, order) => {
				const orderData = response.data;
				if (order) {
					orderData._id = order._id;
					orderData.source_type = order.source_type;
					orderData.source_id = order.source_id;
				}
				this.submissionsLabels.push(orderData);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
			};

			for (let index = 0; index < orders.length; index++) {
				const order = orders[index];
				const id = order.source_id;
				const callbackWrapper = (response) => {
					callback(response, order);
				};
				if (order.source_type === 'orderonline') {
					ordersOo.getOrderDetails(id, callbackWrapper, errorCallback);
				}
			}
		},
		fetchProductCodes(orders) {
			this.labelsFetchingStatus.push('code');
			const productIds = [];
			for (let index = 0; index < orders.length; index++) {
				const order = orders[index];
				if (order.type === 'storefront') {
					const cartItems = order.cart_items || [];
					for (let itemIndex = 0; itemIndex < cartItems.length; itemIndex++) {
						const cartItem = cartItems[itemIndex];
						const cartItemProductId = cartItem.product_id;
						if (cartItemProductId && cartItemProductId.$oid) {
							const productId = cartItemProductId.$oid;
							const idIndex = productIds.findIndex(id => id === productId);
							if (idIndex === -1) {
								productIds.push(productId);
							}
						}
					}
				} else if (order.type === 'form') {
					const productId = order.product_id;
					const idIndex = productIds.findIndex(id => id === productId);
					if (idIndex === -1) {
						productIds.push(productId);
					}
				}
			}
			const params = {
				ids: JSON.stringify(productIds),
			};
			const callback = (response) => {
				const productCodes = response.data;
				this.productCodes = productCodes;
				const index = this.labelsFetchingStatus.findIndex(status => status === 'code');
				if (index !== -1) {
					this.labelsFetchingStatus.splice(index, 1);
				}
				if (this.labelsFetchingStatus.length === 0) {
					this.isShowPackingSlip = true;
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				const index = this.labelsFetchingStatus.findIndex(status => status === 'code');
				if (index !== -1) {
					this.labelsFetchingStatus.splice(index, 1);
				}
			};
			productsApi.getCodes(params, callback, errorCallback);
		},
		loadCourierImages() {
			shippingCouriers.push({ key: 'jx', label: 'JX' });
			shippingCouriers.forEach((courier) => {
				const callback = (response) => {
					this.courierLogos.push({ key: courier.key, ...response });
				};
				const url = `/images/logo-${courier.key}.png`;
				imageURLtoBase64(url, callback);
			});
		},
		loadOOIcon() {
			const callback = (response) => {
				this.ooLogo = response;
			};
			const url = '/img/ostock.svg';
			imageURLtoBase64(url, callback);
		},
		getLastShipmentHistory(order) {
			const lastHistory = getLastShipmentHistory(order);
			return lastHistory;
		},
		isHasShipment(order) {
			return !!this.getLastShipmentHistory(order);
		},
		getShipmentDate(order) {
			const shipmentHistory = this.getLastShipmentHistory(order);
			let date = shipmentHistory ? shipmentHistory.date : '';
			if (date !== '') {
				const isValidDate = dayjs(date).isValid();
				const parseFormat = isValidDate
					? 'YYYY-MM-DD HH:mm'
					: 'DD-MM-YYYY HH:mm';
				date = dayjs(date, parseFormat).format('DD-MM-YYYY HH:mm');
			}
			return date;
		},
		getShipmentNotes(order) {
			const shipmentHistory = this.getLastShipmentHistory(order);
			const notes = shipmentHistory ? shipmentHistory.notes : '';
			return notes;
		},
		getShipmentStatusIcon(order) {
			const shipmentHistory = this.getLastShipmentHistory(order);
			const status = shipmentHistory ? shipmentHistory.status : '';
			const courier = order?.shipping?.courier ?? false;
			const icon = courier
				? getShipmentIcon(status, courier)
				: getShipmentIcon(status);
			return icon;
		},
		onFilterMemberChange(selected) {
			// If 'unassigned' is selected, then remove all others selected members
			const length = selected.length;
			const emptyIndex = selected.findIndex(({ _id }) => _id === 'empty');
			const isEmptyLast = length > 0 && emptyIndex === length - 1;
			const isEmptyNotLast =				length > 0 && emptyIndex !== length - 1 && emptyIndex !== -1;
			if (isEmptyLast) {
				const cs = { _id: 'empty', name: 'Unassigned' };
				this.$set(this, 'selectedMember', [cs]);
			} else if (isEmptyNotLast) {
				this.selectedMember.splice(emptyIndex, 1);
			}
		},
		onFilterResellerChange(selected) {
			// If 'unassigned' is selected, then remove all others selected members
			const length = selected.length;
			const emptyIndex = selected.findIndex(({ _id }) => _id === 'all');
			const isEmptyLast = length > 0 && emptyIndex === length - 1;
			const isEmptyNotLast =				length > 0 && emptyIndex !== length - 1 && emptyIndex !== -1;
			if (isEmptyLast) {
				const cs = { _id: 'all', name: 'All' };
				this.$set(this, 'selectedFilterReseller', [cs]);
			} else if (isEmptyNotLast) {
				this.selectedFilterReseller.splice(emptyIndex, 1);
			}
		},
		showPickup() {
			this.isPickupClicked = true;
			// this.isPickupVisible = true;
			this.checkAgreement();
		},
		showSmartPickup() {
			this.isPickupClicked = true;
			// this.isPickupVisible = true;
			this.checkAgreement(true);
		},
		checkAgreement(smart = false) {
			let isAccepted = false;
			if (this.isOwner) {
				const settings = duplicateVar(this.user.settings);
				if (settings.agreements) {
					const agreements = settings.agreements;
					const agreementName = 'logistic';
					const agreement = agreements.find(
						({ name }) => name === agreementName,
					);
					if (agreement) {
						isAccepted = agreement.accepted && agreement.version === AGREEMENTS_VERSION.LOGISTIC;
					}
				}
			} else {
				isAccepted = true;
			}
			if (isAccepted) {
				if (smart) {
					this.isSmartPickupVisible = true;
				} else {
					this.isPickupVisible = true;
				}
			}
		},
		onAgreementAccepted() {
			this.isPickupVisible = true;
		},
		onPickupSuccess(params) {
			const { orders, pickup, courier } = params;

			const data = orders.map((order) => {
				const payload = {
					receipt_number: order.receipt_number,
					pickup,
				};
				if (order.status && order.status !== '') {
					payload.status = order.status;
				}
				const item = {
					order_id: order.order_id,
					payload,
				};
				return item;
			});
			this.updateOrders(data);

			this.updateSelectedOrders(data);

			this.pickupCourier = courier;

			// Show Pickup Notice
			this.isPickupNoticeVisible = true;
		},
		updateSelectedOrders(updatedOrders) {
			for (let index = 0; index < updatedOrders.length; index++) {
				const order = updatedOrders[index];
				const orderIdInt = parseInt(order.order_id);
				const payload = order.payload;
				const orderIndex = this.selectedSubmissions.findIndex(item => item.order_id === orderIdInt);
				if (orderIndex !== -1) {
					const submission = this.selectedSubmissions[orderIndex];
					const keys = Object.keys(payload);
					for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
						const key = keys[keyIndex];
						const value = payload[key];
						if (key === 'receipt_number') {
							const shipping = duplicateVar(submission.shipping);
							shipping.receipt_number = value;
							submission.shipping = shipping;
						} else if (key === 'pickup') {
							const shipping = duplicateVar(submission.shipping);
							shipping.pickup = value;
							submission.shipping = shipping;
						} else if (key === 'status') {
							submission.status = value;
						}
					}
					this.$set(this.selectedSubmissions, orderIndex, submission);
				}
			}
		},
		isBlockedIp(ip) {
			const blockedIps =				this.user && this.user.settings && this.user.settings.blocked_ip
				? this.user.settings.blocked_ip
				: [];
			return blockedIps.includes(ip);
		},
		isEditEnabled(submission) {
			// return this.isAdmin || (submission.status !== 'completed' && this.isUserCan('order_edit') && !submission.shipping.pickup && submission.payment.method !== 'instant');
			return (
				submission.status !== 'completed'
				&& this.isUserCan('order_edit')
				&& !submission.shipping.pickup
			);
		},
		onPickupUnselect(ids) {
			for (let index = 0; index < ids.length; index++) {
				const id = ids[index];
				this.removeSelected(id);
			}
		},
		removeSelected(id) {
			const index = this.selectedSubmissions.findIndex(({ _id }) => _id === id);
			if (index !== -1) {
				this.selectedSubmissions.splice(index, 1);
			}
			const selectedIndex = this.selected.findIndex(theId => theId === id);
			if (selectedIndex !== -1) {
				this.selected.splice(selectedIndex, 1);
			}
		},
		showShippingLabel() {
			if (this.selectedSubmissions.length > 0) {
				this.isPickupNoticeVisible = false;
				this.isShowPackingSlip = true;
			}
		},
		blockIp() {
			this.isBlockingIp = true;
			// const settings = duplicateVar(this.userSettings);
			// eslint-disable-next-line camelcase
			const blockedIps = this?.userSettings?.blocked_ip ?? [];
			const settings = {};
			settings.blocked_ip = blockedIps;
			const callback = () => {
				this.isBlockingIp = false;
				this.$notify({
					group: 'general',
					title: 'General',
					text: 'Settings updated!',
					type: 'success',
				});
				this.setSettings(settings);
			};
			const errorCallback = () => {
				this.isBlockingIp = false;
				this.$notify({
					group: 'general',
					title: 'General',
					text: 'Failed to update settings, please try again',
					type: 'error',
				});
			};
			userApi.updateSettings(settings, callback, errorCallback);
		},
		resetForm() {
			this.clearForms();
			this.selectedForm = duplicateVar(defaultForm);
		},
		clearSelectedProduct() {
			this.selectedProduct = null;
			const query = duplicateVar(this.$route.query);

			const params = {};

			if (query.product_id) {
				delete query.product_id;
			}

			params.query = query;

			this.$router.push(params);
		},
		onSelectProducts(products) {
			// Clear Selected Product
			this.clearSelectedProduct();
			if (products.length === 1) {
				const product = products[0];
				const productId = product?._id?.$oid;
				this.fetchForms(productId);
			} else {
				this.resetForm();
			}
			this.productIds = products.map(product => product?._id?.$oid);
			this.applyFilter();
		},
		closePackingSlip() {
			this.isShowPackingSlip = false;
			// this.submissionsLabels = [];
		},
		loadLogoIcons() {
			this.loadOrderOnlineLogo();
		},
		// Replaced to Ostock Logo
		loadOrderOnlineLogo() {
			const callback = (response) => {
				this.orderOnlineLogo = response;
			};
			// const url = '/img/ostock-by-oo.svg';
			const url = '/img/orderonline.svg';
			imageURLtoBase64(url, callback);
		},
		overviewAction(key) {
			this.selectedStatus = [];
			this.filterDeliveryStatus = '';
			this.filterIsManifested = false;
			this.isDeleted = null;
			this.sourceType = '';
			this.clearFilters();
			if (key === 'shipping_pending') {
				this.isDeleted = false;
				this.selectedStatus = ['Pending'];
				this.filterDeliveryStatus = '';
				this.filterIsManifested = false;
			} else if (key === 'shipping_processed') {
				this.isDeleted = false;
				this.selectedStatus = ['Processing'];
				this.filterDeliveryStatus = 'processing';
				this.filterIsManifested = false;
			} else if (key === 'shipping_delivery') {
				this.isDeleted = false;
				this.selectedStatus = ['Processing'];
				this.filterDeliveryStatus = 'processing';
				this.filterIsManifested = true;
			} else if (key === 'shipping_completed') {
				this.isDeleted = false;
				this.selectedStatus = ['Completed'];
				this.filterDeliveryStatus = 'delivered';
				this.filterIsManifested = true;
			} else if (key === 'shipping_return_to_shipper') {
				this.isDeleted = false;
				this.selectedStatus = ['Completed', 'Processing'];
				this.filterDeliveryStatus = 'cancelled';
				this.filterIsManifested = true;
				this.returnStatus = 'delivered';
			} else if (key === 'shipping_cancelled') {
				this.isDeleted = true;
				this.sourceType = 'orderonline';
			} else if (key === 'shipping_refunded') {
				this.selectedStatus = ['Refunded'];
			} else if (key === 'submission_count') {
				this.selectedStatus = [];
				this.filterDeliveryStatus = '';
				this.filterIsManifested = false;
			} else if (key === 'shipping_process_return') {
				this.returnStatus = 'processing';
				this.filterIsManifested = true;
				this.isDeleted = false;
			} else if (key === 'shipping_return_completed') {
				this.returnStatus = 'completed';
				this.filterIsManifested = true;
				this.isDeleted = false;
			} else if (key === 'shipping_return_broken') {
				this.returnStatus = 'broken';
				this.filterIsManifested = true;
				this.isDeleted = false;
			}
			this.applyFilter();
		},
		checkColumns(columns) {
			const productName = 'product_name';
			if (!columns.includes(productName)) {
				columns.push(productName);
			}
			return columns;
		},
		showProduct(order) {
			this.isShowModalProduct = true;
			this.selectedSubmission = order;
		},
		hideShowProduct() {
			this.isShowModalProduct = false;
			this.selectedSubmission = {};
		},
		getOrderDisplayStatus,
		exportOrderSupplier(type) {
			const since = this.moment(this.filterDate.start);
			const until = this.moment(this.filterDate.end);

			const diffInDays = until.diff(since, 'days');

			if (diffInDays <= 90) {
				this.exportOrders(type);
			} else {
				this.isShowNoticeExport = true;
			}
		},
		fetchStatsCustomerCredit() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			const params = {
				since: startDate,
				until: endDate,
			};
			const callback = (res) => {
				const data = res?.data;
				this.credit = data;
			};
			const err = (e) => {
				console.log(e);
			};

			statisticScoreboardCredit(params, callback, err);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isUserCan: 'isUserCan',
			isSupport: 'isSupport',
			isRoleAdmin: 'isRoleAdmin',
			locale: 'locale',
			bankAccounts: 'bankAccounts',
			store: 'store',
			ordersColumns: 'ordersColumns',
			overview: 'overview',
			followUpConversionStatistic: 'followUpConversionStatistic',
			trackingStatistic: 'trackingStatistic',
			isHasFeature: 'isHasFeature',
			products: 'submissions/products',
			forms: 'submissions/forms',
			submissions: 'submissions/all',
			isFetching: 'submissions/isFetching',
			page: 'submissions/page',
			isAll: 'submissions/isAll',
			newOrderIds: 'submissions/newOrderIds',
			allTags: 'submissions/tags',
			orderDetails: 'submissions/details',
			teamMembers: 'members/all',
			resellers: 'resellers/all',
			isFetchingMembers: 'members/isFetching',
			transactionChartOptions: 'transactionChartOptions',
			transactionChartData: 'transactionChartData',
			customerChartOptions: 'customerChartOptions',
			customerChartData: 'customerChartData',
			presetRangeLabel: 'presetRangeLabel',
			filterDatePresets: 'filterDatePresets',
			isFullWidth: 'isFullWidth',
			provinces: 'productCreator/provinces',
			cities: 'productCreator/cities',
			subdistricts: 'productCreator/subdistricts',
		}),
		isFilterOn() {
			const queryParameters = this.$route.query;

			// Check if there are any query parameters
			if (Object.keys(queryParameters).length > 0) {
				return true;
			}

			return false;
		},
		histories() {
			return this.selectedSubmission.shipping.trackings && this.selectedSubmission.shipping.trackings.history ? duplicateVar(this.selectedSubmission.shipping.trackings.history).reverse() : [];
		},
		productsList() {
			// const allProduct = duplicateVar(defaultProduct);
			// let list = [allProduct];
			// list = list.concat(this.products);
			return this.products;
		},
		formsList() {
			const allForm = duplicateVar(defaultForm);
			let list = [allForm];
			list = list.concat(this.forms);
			return list;
		},
		submissionsFiltered() {
			const filterKeyword = this.filterKeyword.toLowerCase();
			return this.submissions.filter(submission => submission.customer_data.name.toLowerCase().includes(filterKeyword));
		},
		followUpName() {
			const name = this.selectedSubmission.customer_data.name;
			return name;
		},
		followUpNumber() {
			const countryCode = '62';
			let phone = this.selectedSubmission.customer_data.phone;
			if (phone.charAt(0) === '+') {
				phone = phone.slice(1, phone.length);
			} else if (phone.charAt(0) === '0') {
				phone = phone.slice(1, phone.length);
				phone = `${countryCode}${phone}`;
			} else if (phone.charAt(0) !== '6' && phone.charAt(1) !== '2') {
				phone = `${countryCode}${phone}`;
			}
			return phone;
		},
		followUpText() {
			const textData =				this.followUpData && this.followUpData[this.followUpType]
				? this.followUpData[this.followUpType]
				: '';
			const textFormat =				typeof textData === 'object' ? textData.format : textData;
			const text = this.generateFollowUpText(textFormat);
			return text;
		},
		followUpURL() {
			const isWindowsFirefox = isWindows() && isFirefox();
			const waProtocol = 'whatsapp://send';
			const waUrl = isWindowsFirefox
				? 'https://web.whatsapp.com/send'
				: 'https://api.whatsapp.com/send';
			// const waApiUrl = this.isMobileOrTablet() ? 'whatsapp://send' : waUrl;
			const waApiUrl = this.isMobileOrTablet() ? waProtocol : waUrl;
			// if (this.isMobileOrTablet() && isChrome()) {
			// 	waApiUrl = waUrl;
			// }
			const text = encodeURIComponent(this.followUpTextEdit);
			const url = `${waApiUrl}?phone=${this.followUpNumberEdit}&text=${text}`;
			return url;
		},
		phoneCallUrl() {
			const url = `tel:${this.followUpNumberEdit}`;
			return url;
		},
		selectAll: {
			get() {
				return this.submissions
					? this.selected.length === this.submissions.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.submissions.forEach((submission) => {
						selected.push(submission._id);
					});
					this.selectedSubmissions = duplicateVar(this.submissions);
				} else {
					this.selectedSubmissions = [];
				}
				this.selected = selected;
			},
		},
		fetchParams() {
			const productId = this.productId ? this.productId : 0;
			const formId = this.formId ? this.formId : 0;
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);
			const status = this.selectedStatus.join(',').toLowerCase();
			const paymentStatus = this.selectedPaymentStatus
				? this.selectedPaymentStatus.key
				: 'all';
			const paymentMethod = this.selectedPaymentMethod
				? this.selectedPaymentMethod.key
				: 'all';
			const bumpStatus = this.selectedBumpStatus
				? this.selectedBumpStatus.key
				: 'all';
			const teamMembers = this.selectedMember.map(el => el._id);
			const packingSlip = this.selectedPackingSlip
				? this.selectedPackingSlip.key
				: 'all';
			const receiptNumber = this.filterReceiptNumber;
			const pickupStatus = this.filterPickup ? this.filterPickup.key : 'all';
			// const reseller = this.filterReseller ? this.filterReseller.key : 'f';
			const resellers = this.selectedFilterReseller.map(el => el._id);
			let courier = this.filterCourier ? this.filterCourier.key : 'all';

			const filterDeliveryStatus = this.filterDeliveryStatus;
			const filterIsManifested = this.filterIsManifested;

			const isDeleted = this.isDeleted;
			const sourceType = this.sourceType;
			const province = this.selectedProvince;
			const city = this.selectedCity;
			const subdistrict = this.selectedSubdistrict;

			const returnStatus = this.returnStatus;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: startDate,
				until: endDate,
			};

			if (this.submissionIds && this.submissionIds !== '') {
				params.submission_ids = this.submissionIds;
			}

			if (province) {
				params.province = province.province_name;
			}

			if (city) {
				params.city = city.city_name_with_type;
			}

			if (subdistrict) {
				params.subdistrict = subdistrict.subdistrict_name;
			}

			if (status !== '') {
				params.status = status;
			}

			if (this.selectedCouponCode && this.selectedCouponCode !== '') {
				params.coupon = this.selectedCouponCode;
			}

			if (this.processingAt && this.processingAt !== '') {
				params.processing_at = this.processingAt;
			}

			if (
				this.filterProcessingAtSince
				&& this.filterProcessingAtSince !== ''
				&& this.filterProcessingAtUntil
				&& this.filterProcessingAtUntil !== ''
			) {
				params.processing_at_since = this.filterProcessingAtSince;
				params.processing_at_until = this.filterProcessingAtUntil;
			}

			if (
				this.filterCompletedSince
				&& this.filterCompletedSince !== ''
				&& this.filterCompletedUntil
				&& this.filterCompletedUntil !== ''
			) {
				params.completed_at_since = this.filterCompletedSince;
				params.completed_at_until = this.filterCompletedUntil;
			}

			if (
				this.filterPaidSince
				&& this.filterPaidSince !== ''
				&& this.filterPaidUntil
				&& this.filterPaidUntil !== ''
			) {
				params.paid_at_since = this.filterPaidSince;
				params.paid_at_until = this.filterPaidUntil;
			}

			if (this.filterKeyword && this.filterKeyword !== '') {
				params.keyword = this.filterKeyword;
			}

			// if (this.member && this.member !== '') {
			// 	params.team_member_id = this.member;
			// }

			// if (this.selectedMember) {
			// 	params.team_member_id = this.selectedMember._id;
			// }

			if (this.selectedMember.length > 0) {
				params.team_member_ids = JSON.stringify(teamMembers);
			} else if (this.member && this.member !== '') {
				const members = this.member.split(',');
				params.team_member_ids = JSON.stringify(members);
			}

			if (this.selectedFilterReseller.length > 0) {
				params.reseller_ids = JSON.stringify(resellers);
			} else if (this.reseller_ids && this.reseller_ids !== '') {
				params.reseller_ids = JSON.stringify(this.reseller_ids.split(','));
			}

			// Tag
			if (this.filterTags && this.filterTags.length > 0) {
				const tags = this.filterTags.map(el => el.name);
				params.tags = JSON.stringify(tags);
			}

			if (paymentStatus && paymentStatus !== 'all') {
				params.payment_status = paymentStatus;
			}

			if (paymentMethod && paymentMethod !== 'all') {
				params.payment_method = paymentMethod;
			}

			if (bumpStatus && bumpStatus !== 'all') {
				const isBumpChecked = bumpStatus === 'checked' ? 1 : 0;
				params.bump = isBumpChecked;
			}

			if (packingSlip !== 'all') {
				params.is_printed = parseInt(packingSlip);
			}

			if (receiptNumber !== '') {
				params.receipt = receiptNumber;
			}

			// Courier
			if (courier && courier !== 'all') {
				if (courier === 'jnt') {
					courier = 'J&T';
				}
				params.courier = courier;
			}

			// Pickup
			if (pickupStatus && pickupStatus !== 'all') {
				const isPickup = pickupStatus === 'yes' ? 1 : 0;
				params.pickup = isPickup;
			}

			// Advanced Filters
			const filterKeys = Object.keys(this.filters);
			for (let index = 0; index < filterKeys.length; index++) {
				const key = filterKeys[index];
				const filter = this.filters[key];
				if (filter !== '') {
					params[key] = filter;
				}
			}

			if (productId !== 0) {
				params.product_id = productId;
			}

			if (formId !== 0) {
				params.form_id = formId;
			}

			// Product IDs
			if (this.selectedProducts.length > 0) {
				const productIds = this.selectedProducts.map(({ _id }) => _id);
				params.product_ids = JSON.stringify(productIds);
			}

			// Product IDs
			if (this.productIds.length > 0) {
				const productIds = this.productIds;
				params.product_ids = JSON.stringify(productIds);
			}

			if (filterDeliveryStatus !== '') {
				params.delivery_status = filterDeliveryStatus;
			}

			if (filterIsManifested !== '') {
				params.is_manifested = filterIsManifested;
			}

			if (isDeleted !== null) {
				params.is_deleted = isDeleted;
			}

			if (sourceType !== '') {
				params.source_type = sourceType;
			}

			if (returnStatus) {
				params.return_status = returnStatus;
			}

			return params;
		},
		productId() {
			return this.$route.query.product_id;
		},
		formId() {
			return this.$route.query.form_id ? this.$route.query.form_id : 0;
		},
		bankAccountsDisplay() {
			const bankAccounts = this.bankAccounts.map((bankAccount) => {
				let text = `${bankAccount.label}`;
				text += `\nNo. Rek: ${bankAccount.account_number}`;
				text += `\nAtas Nama: ${bankAccount.account_name}`;
				return text;
			});
			const bankAccountsText = bankAccounts.join('\n\n');
			return bankAccountsText;
		},
		orderStatusTooltip() {
			const content = /* html */ `
				<div class="order-status-tooltip text-left">
					<div><b>Pending</b>: Order diterima</div>
					<div><b>Processing</b>: Order telah diproses</div>
					<div><b>Delivery</b>: Order sedang dalam perjalanan </div>
					<div><b>Delivered</b>: Order telah sampai tujuan</div>
					<div><b>On Process Return</b>: Order dalam perjalanan dikembalikan ke shipper</div>
					<div><b>Returned</b>: Order yang dikembalikan ke shipper</div>
					<div><b>Return Completed</b>: Order telah kembali sesuai</div>
					<div><b>Return Broken</b>: Order telah kembali tidak sesuai</div>
					<div><b>Cancelled</b>: Order telah dibatalkan</div>
					<div><b>Refunded</b>: Credit orderan dikembalikan</div>
					<!-- <div class="mt-2"><a class="link-light" href="https://help.ostock.id/mengatur-pemesanan" target="_blank">Baca Selengkapnya</a></div> -->
				</div>
			`;
			const options = {
				placement: 'top',
				content,
				html: true,
				autoHide: false,
				popperOptions,
			};
			return options;
		},
		followUpTooltip() {
			const content = /* html */ `
				<div class="text-left">
					<div class="d-flex align-items-center"><div class="mr-2 dot success"></div> Sudah difollow-up</div>
					<div class="d-flex align-items-center"><div class="mr-2 dot warning"></div> Follow-up hari ini</div>
					<div class="d-flex align-items-center"><div class="mr-2 dot"></div> Belum difollow-up</div>
					<div class="mt-2"><a class="link-light" href="https://help.ostock.id/follow-up-sequence" target="_blank">Baca Selengkapnya</a></div>
				</div>
			`;
			const options = {
				placement: 'top',
				content,
				html: true,
				autoHide: false,
				popperOptions,
			};
			return options;
		},
		status() {
			const status = this.$route.query.status ? this.$route.query.status : '';
			return status;
		},
		couponCode() {
			const couponCode = this.$route.query.coupon
				? this.$route.query.coupon
				: '';
			return couponCode;
		},
		tags() {
			// const tags = this.$route.query.tags ? this.$route.query.tags : '';
			const tags = this.$route.query.tags;
			return tags;
		},
		// processingAt() {
		// 	const processingAt = this.$route.query.processing_at ? this.$route.query.processing_at : '';
		// 	return processingAt;
		// },
		processingAtSinceQuery() {
			const processingAtSince = this.$route.query.processing_at_since;
			return processingAtSince;
		},
		processingAtUntilQuery() {
			const processingAtUntil = this.$route.query.processing_at_until;
			return processingAtUntil;
		},
		completedSinceQuery() {
			const completedAtSince = this.$route.query.completed_at_since;
			return completedAtSince;
		},
		completedUntilQuery() {
			const completedAtUntil = this.$route.query.completed_at_until;
			return completedAtUntil;
		},
		paidSinceQuery() {
			const since = this.$route.query.paid_at_since;
			return since;
		},
		paidUntilQuery() {
			const until = this.$route.query.paid_at_until;
			return until;
		},
		member() {
			const member = this.$route.query.member;
			return member;
		},
		resellerIds() {
			const resellerIds = this.$route.query.reseller_ids;
			return resellerIds;
		},
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		isRoleAdmin() {
			return this.user && this.user.role === 'owner_admin';
		},
		isOwner() {
			return this.user && this.user.role === 'owner';
		},
		orderLink() {
			const productUrl = this.selectedProduct.url;
			const isAdminOrOwner = this.isRoleAdmin || this.isOwner;
			const belongsTo = this.user ? duplicateVar(this.user._id) : '';
			const params = {};
			if (this.formId) {
				params.form = this.formId;
			}
			if (!isAdminOrOwner) {
				params.belongs_to = belongsTo;
			}
			const urlSuffix = buildQuery(params);
			const isHasQueries = urlSuffix.length > 0;
			const link = isHasQueries ? `${productUrl}?${urlSuffix}` : productUrl;
			return link;
		},
		columnsQuery() {
			return this.$route.query.columns;
		},
		columns() {
			const columnsArray = this.columnsQuery
				? this.columnsQuery.split(',')
				: this.ordersColumns;
			return this.checkColumns(columnsArray);
		},
		categorizedColumns() {
			return groupBy(this.allOrdersColumns, 'category');
		},
		paymentStatusQuery() {
			return this.$route.query.payment_status;
		},
		filterResellerQuery() {
			return this.$route.query.reseller_ids;
		},
		paymentMethodQuery() {
			return this.$route.query.payment_method;
		},
		packingSlipQuery() {
			return this.$route.query.is_printed;
		},
		receiptNumberQuery() {
			return this.$route.query.receipt_number;
		},
		bumpQuery() {
			return this.$route.query.bump;
		},
		pickupQuery() {
			return this.$route.query.pickup;
		},
		courierQuery() {
			return this.$route.query.courier;
		},
		utmSource() {
			return this.$route.query.utm_source;
		},
		utmMedium() {
			return this.$route.query.utm_medium;
		},
		utmCampaign() {
			return this.$route.query.utm_campaign;
		},
		utmTerm() {
			return this.$route.query.utm_term;
		},
		utmContent() {
			return this.$route.query.utm_content;
		},
		customerServices() {
			return this.teamMembers.filter(teamMember => teamMember.role === 'cs');
		},
		isUserCanPaid() {
			const isUserCanPaid = this.isUserCan('order_update_paid');
			return isUserCanPaid;
		},
		isUserCanUnpaid() {
			const isUserCanUnpaid = this.isUserCan('order_update_unpaid');
			return isUserCanUnpaid;
		},
		isUserCanUpdatePayment() {
			const isUserCanUpdatePayment = this.isUserCanPaid && this.isUserCanUnpaid;
			return isUserCanUpdatePayment;
		},
		totalCustomers() {
			const cities = this.customerChartData.allCities || [];
			return cities.reduce((prev, { count }) => prev + count, 0);
		},
		selectedOrderDetail() {
			return this.orderDetails.find(
				detail => detail._id === this.selectedSubmission._id,
			);
		},
		memberOptions() {
			const options = duplicateVar(this.customerServices);
			const empty = {
				_id: 'empty',
				name: '- Unassigned -',
			};
			options.unshift(empty);
			return options;
		},
		resellerOptions() {
			const options = duplicateVar(this.resellers);
			const empty = {
				_id: 'all',
				name: 'All',
			};
			options.unshift(empty);
			return options;
		},
		isPickupEnabled() {
			const plan = this.user ? this.user.package : '';
			return plan !== 'free' && plan !== 'personal';
		},
		couriersOptions() {
			const allCourier = { key: 'all', label: 'All Couriers' };
			const couriers = duplicateVar(shippingCouriers);
			couriers.unshift(allCourier);
			return couriers;
		},
		disabledPickupTooltip() {
			const content = /* html */ `
				<div>
					<div>This feature is for <br> Professional, Business or Enterprise plan only</div>
					<a href="https://ostock.id/plans/" target="_blank" class="link-light mt-2">Upgrade Now</a>
				</div>
			`;
			const options = {
				placement: 'top',
				content,
				html: true,
				autoHide: false,
				popperOptions,
			};
			return options;
		},
		isHasInstant() {
			const instants = this.selectedSubmissions.filter((order) => {
				const paymentMethod = order?.payment?.method ?? 'bank_transfer';
				return paymentMethod === 'instant';
			});
			return instants.length > 0;
		},
		isHasNonInstant() {
			const notInstants = this.selectedSubmissions.filter((order) => {
				const paymentMethod = order?.payment?.method ?? 'bank_transfer';
				return paymentMethod !== 'instant';
			});
			return notInstants.length > 0;
		},
		// filterDatePresets() {
		// 	const presets = duplicateVar(this.globalDatePresets);
		// 	delete presets.lifetime;
		// 	return presets;
		// },
		// isMobile() {
		// 	return isMobile();
		// },
		isFetchingLabel() {
			return this.labelsFetchingStatus.length > 0;
		},
		isLogoLoaded() {
			return this.ooLogo && this.orderOnlineLogo;
		},
		isPackingSlipVisible() {
			const isSourcesLoaded = this.submissionsLabels.length === this.selectedSubmissions.length;
			return this.isShowPackingSlip && isSourcesLoaded && this.isLogoLoaded;
		},
		selectedPendingOrders() {
			const filter = (order) => {
				const index = this.selected.findIndex(id => id === order._id && order.status === 'pending');
				return index !== -1;
			};
			return this.submissions.filter(filter);
		},
		submissionIdsParam() {
			return this.$route.query.submission_ids ?? '';
		},
	},
	watch: {
		'$route.query.submission_ids': function (newSubmissionIds, oldSubmissionIds) {
			if (newSubmissionIds !== oldSubmissionIds) {
				this.init();
			}
		},
		user(user) {
			if (user) {
				this.init();
			}
		},
		selectedProvince() {
			this.fetchCities(this.selectedProvince.province_id);
		},
		selectedCity() {
			this.fetchSubdistricts(this.selectedCity.city_id);
		},
		productId(productId) {
			this.selected = [];
			this.fetchData();
			if (!productId) {
				this.selectedProduct = defaultProduct;
			} else {
				this.fetchForms(productId);
			}
		},
		products(products) {
			if (this.productId) {
				let product = products.find(product => product._id === this.productId);
				if (!product) {
					product = defaultProduct;
				}
				this.selectedProduct = product;
			}
		},
		selectedProduct(product) {
			const query = duplicateVar(this.$route.query);
			const params = {};

			const productId = product ? product._id : false;

			if (productId && productId === 0) {
				delete query.product_id;
				this.resetForm();
			} else if (productId) {
				query.product_id = productId;
				if (this.formId !== 0) {
					query.form_id = this.formId;
				}
			}

			params.query = query;

			this.$router.push(params);
		},
		forms(forms) {
			if (this.formId) {
				let form = forms.find(form => form._id === this.formId);
				if (!form) {
					form = defaultForm;
				}
				this.selectedForm = form;
			}
		},
		selectedForm(form) {
			const formId = form._id;
			const query = duplicateVar(this.$route.query);
			query.product_id = this.productId;

			if (formId !== 0 && formId !== '0') {
				query.form_id = formId;
			} else {
				delete query.form_id;
			}

			const params = { query };
			this.$router.push(params);
		},
		formId() {
			this.fetchData();
		},
		status() {
			this.fetchData();
		},
		couponCode() {
			this.fetchData();
		},
		teamMembers() {
			if (this.member && this.member !== '' && this.teamMembers.length > 0) {
				this.checkFilterMembers();
			}
		},
		filterResellerIds() {
			if (
				this.resellerIds
				&& this.resellerIds !== ''
				&& this.filterResellerIds.length > 0
			) {
				this.checkFilterResellerIds();
			}
		},
		utmSource() {
			this.fetchData();
		},
		utmMedium() {
			this.fetchData();
		},
		utmCampaign() {
			this.fetchData();
		},
		utmTerm() {
			this.fetchData();
		},
		utmContent() {
			this.fetchData();
		},
	},
	created() {
		this.isDeviceMobile = isMobile();
		this.loadCourierImages();
		this.resetNewOrders();
		this.loadOOIcon();
		this.loadLogoIcons();
		if (this.user) {
			this.init();
		}
		this.checkFilters();
		this.initAdvancedFilter();
		this.fetchStatsCustomerCredit();

		window.addEventListener('scroll', this.handleScroll);
		document.addEventListener('scroll', this.onDocumentScroll, true);
		window.addEventListener('resize', this.checkListTable, true);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('scroll', this.onDocumentScroll, true);
		window.removeEventListener('resize', this.checkListTable, true);
	},
	updated() {
		this.$nextTick(() => {
			this.setVerticalScroll();
			this.checkListTable();
		});
	},
};
